'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var cookie = require('@rentspree/cookie');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var componentV2 = require('@rentspree/component-v2');
var gradient = require('@rentspree/component-v2/dist/button/gradient');
var React = require('react');
var React__default = _interopDefault(React);
require('@rentspree/component-v2/dist/badge');
var PropTypes = _interopDefault(require('prop-types'));
var reactRouterDom = require('react-router-dom');
var axios = _interopDefault(require('axios'));
var getHandleAuthorization = _interopDefault(require('@rentspree/axios-refresh-token'));

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol$1 = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map$1 = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$1 || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var lodash_get = get;

var lodash_isempty = createCommonjsModule(function (module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' ||
        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (nonEnumShadows || isPrototype(value)) {
    return !nativeKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEmpty;
});

/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$1 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$1.toString;

/** Built-in value references. */
var Symbol$2 = root$1.Symbol,
    symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString$1(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$1(value) {
  if (!isObject$1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var lodash_isfunction = isFunction$1;

var STORAGE = {
  USER_TOKEN: 'rentspreeUserToken'
};

var getUserToken = function getUserToken() {
  return lodash_get(cookie.getLocalItem(STORAGE.USER_TOKEN), 'access_token', null);
};

var RENTSPREE_NAVBAR_LOGO_URL = 'https://cdn.rentspree.com/static-files/component-2023/rs-full-logo.svg';

var feedbackImg = "data:image/png;base64,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";

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var _templateObject = taggedTemplateLiteral(['\n  .custom-hubspot-form{\n    &.hs-form {\n      width: 100%;\n      height: 100%;\n      font-family: Source Sans Pro, sans-serif, "simple-line-icons";\n    }\n    .hs-button {\n      width: 100px;\n    }\n    .hs-main-font-element {\n      h1 {\n        margin: 0px 0px 19px;\n        font-size: 26px;\n        color: #333333;\n        strong {\n          font-weight: 600;\n        }\n        @media (max-width: 767px) {\n          font-size: 24px;\n          margin: 0px 0px 15px;\n        }\n      }\n    }\n    .hs-fieldtype-textarea {\n      label {\n        font-size: 16px;\n        color: #4a4a4a;\n        font-weight: normal;\n      }\n      textarea {\n        width: 100%;\n        height: 140px;\n        border-radius: 1px;\n        border: solid 1px #9b9b9b;\n        margin-top: 10px;\n        resize: vertical;\n        font-size: 14px;\n        padding: 10px;\n        @media (max-width: 767px) {\n          height: 197px;\n        }\n        :focus {\n          outline: 0;\n        }\n      }\n    }\n    .hs-submit {\n      margin-top: 20px;\n      text-align: right;\n      .hs-button {\n        width: 150px;\n        height: 40px;\n        border-radius: 22.5px;\n        background-color: #4b97f5;\n        border-width: 0px;\n        color: white;\n        font-size: 14px;\n        font-family: Source Sans Pro, sans-serif;\n        cursor: pointer;\n        font-weight: 600;\n        @media (max-width: 767px) {\n          width: 160px;\n          border-radius: 25px;\n        }\n        :focus {\n          outline: 0;\n        }\n      }\n      @media (max-width: 767px) {\n        margin-top: 14px;\n      }\n    }\n  }\n  .submitted-message {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    p {\n      font-size: 22px;\n      text-align: center;\n      margin: 22px 0px;\n      @media (max-width: 767px) {\n        font-size: 18px;\n      }\n    }\n  }\n'], ['\n  .custom-hubspot-form{\n    &.hs-form {\n      width: 100%;\n      height: 100%;\n      font-family: Source Sans Pro, sans-serif, "simple-line-icons";\n    }\n    .hs-button {\n      width: 100px;\n    }\n    .hs-main-font-element {\n      h1 {\n        margin: 0px 0px 19px;\n        font-size: 26px;\n        color: #333333;\n        strong {\n          font-weight: 600;\n        }\n        @media (max-width: 767px) {\n          font-size: 24px;\n          margin: 0px 0px 15px;\n        }\n      }\n    }\n    .hs-fieldtype-textarea {\n      label {\n        font-size: 16px;\n        color: #4a4a4a;\n        font-weight: normal;\n      }\n      textarea {\n        width: 100%;\n        height: 140px;\n        border-radius: 1px;\n        border: solid 1px #9b9b9b;\n        margin-top: 10px;\n        resize: vertical;\n        font-size: 14px;\n        padding: 10px;\n        @media (max-width: 767px) {\n          height: 197px;\n        }\n        :focus {\n          outline: 0;\n        }\n      }\n    }\n    .hs-submit {\n      margin-top: 20px;\n      text-align: right;\n      .hs-button {\n        width: 150px;\n        height: 40px;\n        border-radius: 22.5px;\n        background-color: #4b97f5;\n        border-width: 0px;\n        color: white;\n        font-size: 14px;\n        font-family: Source Sans Pro, sans-serif;\n        cursor: pointer;\n        font-weight: 600;\n        @media (max-width: 767px) {\n          width: 160px;\n          border-radius: 25px;\n        }\n        :focus {\n          outline: 0;\n        }\n      }\n      @media (max-width: 767px) {\n        margin-top: 14px;\n      }\n    }\n  }\n  .submitted-message {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    p {\n      font-size: 22px;\n      text-align: center;\n      margin: 22px 0px;\n      @media (max-width: 767px) {\n        font-size: 18px;\n      }\n    }\n  }\n']),
    _templateObject2 = taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']),
    _templateObject3 = taggedTemplateLiteral(['\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n'], ['\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n']);

var HubspotFormCSS = styled.createGlobalStyle(_templateObject);

// language=SCSS prefix=dummy{ suffix=}
var FLEX_CENTER = styled.css(_templateObject2);
var INLINE_FLEX_CENTER = styled.css(_templateObject3);

var COLOR = {
  darkBlue: 'rgb(50, 120, 179)',
  blue: 'rgb(108, 164, 210)',
  lightBlue: 'rgb(153, 209, 255)',
  steelBlue: '#37495F',
  darkSteelBlue: 'rgb(39, 50, 66)',
  darkSteelBlue50: 'rgba(39, 50, 66, 0.5)',
  darkDeepBlue: 'rgb(29, 102, 206)',
  deepBlue: 'rgb(61, 138, 247)',
  deepBlueLight: '#3B99FC',
  whiteBlue: '#308DCE',

  darkOrange: 'rgb(184, 76, 26)',
  orange: 'rgb(246, 100, 32)',
  lightOrange: 'rgb(255, 163, 120)',
  newOrange: '#FF8A23',

  darkNegativeRed: '#a72f31',
  negativeRed: '#F15555',

  darkYellow: '#A7903F',
  yellow: '#D3B84D',
  lightYellow: '#FFE79F',

  darkGreen: '#67A033',
  green: '#80C640',
  lightGreen: '#BCF090',

  bgCream: '#f2f1ef',
  cream: 'rgb(220, 214, 176)',
  choc: 'rgb(69, 54, 41)',

  lineGrey: '#e5e5e5',
  bgGrey: '#F1F1F1',
  bgDarkGrey: '#EEEEEE',
  textBlack: '#333333',
  textGrey: '#888888',
  titleBlack: '#666666',
  titleGrey: '#999999',
  white: '#FFFFFF',
  black: '#000000',
  blackInput: '#777777',

  selectionGrey: '#F8F8F8',
  placeholderGrey: '#AAAAAA',

  grayFade: '#eceeef',

  // CAA
  newBlack: '#4A4A4A',
  newGrey: '#E5E5E5'
};

var redirect = function redirect(url) {
  window.location.href = url;
};

var iconApplication = "data:image/svg+xml,%3Csvg%20width%3D%2214%22%20height%3D%2216%22%20viewBox%3D%220%200%2014%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M1.76549%200C1.06658%200%200.5%200.56658%200.5%201.26549V14.7345C0.5%2015.4334%201.06658%2016%201.76549%2016H12.2345C12.9334%2016%2013.5%2015.4334%2013.5%2014.7345V3.97745L9.53277%200H1.76549ZM10.1966%2012.2518L8.39104%2011.3697C8.15778%2011.2557%208.01035%2011.0227%208.01035%2010.7678V10.0756C8.061%2010.0193%208.11922%209.9467%208.18122%209.861C8.42733%209.52155%208.61332%209.14793%208.74242%208.75584C8.97397%208.68621%209.14447%208.47715%209.14447%208.22875V7.49C9.14447%207.32748%209.07056%207.18213%208.95545%207.08055V6.01252C8.95545%206.01252%209.17982%204.35034%206.87622%204.35034C4.57244%204.35034%204.797%206.01252%204.797%206.01252V7.08055C4.68189%207.18213%204.60798%207.32748%204.60798%207.49V8.22875C4.60798%208.42341%204.7127%208.59461%204.86939%208.6936C5.05823%209.49735%205.55308%2010.0756%205.55308%2010.0756V10.7506C5.55308%2010.9968%205.41547%2011.2234%205.19413%2011.3413L3.50788%2012.2401C3.02077%2012.4996%202.71777%2012.9984%202.71777%2013.5405V14.1387H11.0347V13.5767C11.0347%2013.0156%2010.7101%2012.5027%2010.1966%2012.2518ZM10.7807%203.99487H12.751L9.51516%200.721183V2.72938C9.51516%203.42829%2010.0817%203.99487%2010.7807%203.99487Z%22%20fill%3D%22%23333333%22%2F%3E%3C%2Fsvg%3E";

var iconMessage = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2213%22%20viewBox%3D%220%200%2016%2013%22%3E%20%20%20%20%3Cpath%20fill%3D%22%23333%22%20fill-rule%3D%22evenodd%22%20d%3D%22M8%200c4.418%200%208%202.8%208%206.255%200%203.454-3.582%206.255-8%206.255-.372%200-1.254-.195-2.648-.584L.924%2013l1.088-2.597C.671%208.228%200%206.846%200%206.255%200%202.8%203.582%200%208%200zM4.25%205C3.56%205%203%205.448%203%206s.56%201%201.25%201S5.5%206.552%205.5%206s-.56-1-1.25-1zm4%200C7.56%205%207%205.448%207%206s.56%201%201.25%201S9.5%206.552%209.5%206s-.56-1-1.25-1zm4%200C11.56%205%2011%205.448%2011%206s.56%201%201.25%201%201.25-.448%201.25-1-.56-1-1.25-1z%22%2F%3E%3C%2Fsvg%3E";

var URL$1 = {
  ABOUT_US: '/about',
  AGENT_DASHBOARD: '/dashboard/v2',
  DASHBOARD: '/dashboard',
  LOGIN: '/account/login',
  PROFILE: '/account/profile',
  PUBLIC_MESSAGING: '/dashboard/v2/public/messaging',
  RENTER_DASHBOARD: '/dashboard/overview',
  ROOT: '/',
  SUPPORT_URL_RENTER: 'https://support.rentspree.com/en/applicant-help-center',
  SUPPORT_URL: 'https://support.rentspree.com'
};

var generateUrlByUserType = function generateUrlByUserType(userType) {
  return userType === USER_TYPE.RENTER ? URL$1.RENTER_DASHBOARD : URL$1.AGENT_DASHBOARD;
};

var MENU = {
  PROFILE: {
    icon: 'icon-user',
    id: 'profileDropdownMenuItemMyProfile',
    text: 'My Account',
    url: URL$1.PROFILE
  },
  LOGOUT: {
    icon: 'icon-power',
    id: 'profileDropdownMenuItemLogout',
    isDivider: true,
    text: 'Log Out'
  },
  APPLICATIONS: {
    className: 'hideDeskTop',
    id: 'profileDropdownMenuItemDashboard',
    img: iconApplication,
    isDivider: true,
    noIconFilter: true,
    showMobileIcon: true,
    text: 'Applications',
    url: URL$1.RENTER_DASHBOARD
  },
  SWITCH_AGENT: {
    icon: 'icon-refresh',
    id: 'profileDropdownMenuItemAgen',
    text: 'Agent? Click here'
  },
  SWITCH_RENTER: {
    icon: 'icon-refresh',
    id: 'profileDropdownMenuItemRenter',
    text: 'Renter? Click here'
  },
  HOME: {
    className: 'hideDeskTop',
    id: 'profileDropdownMenuItemHome',
    text: 'Home',
    url: URL$1.DASHBOARD
  },
  ABOUT_US: {
    className: 'hideDeskTop',
    id: 'navAbout',
    target: '',
    text: 'About us',
    url: URL$1.ABOUT_US
  },
  SUPPORT_RENTER: {
    className: 'hideDeskTop',
    id: 'navSupport',
    isDivider: false,
    target: '_blank',
    text: 'Support',
    url: URL$1.SUPPORT_URL_RENTER
  },
  SUPPORT: {
    className: 'hideDeskTop',
    id: 'navSupport',
    isDivider: false,
    target: '_blank',
    text: 'Support',
    url: URL$1.SUPPORT_URL
  },
  FEEDBACK: {
    className: 'hideDeskTop',
    id: 'giveFeedback',
    isDivider: false,
    text: 'Give Feedback'
  },
  MESSAGING: {
    className: 'hideDeskTop',
    id: 'messagingNavBarLink',
    img: iconMessage,
    isDivider: true,
    key: 'message',
    noIconFilter: true,
    showMobileIcon: true,
    text: 'Messages',
    url: URL$1.PUBLIC_MESSAGING
  },
  LOGIN: {
    id: 'navLogin',
    target: '_blank',
    text: 'Login',
    url: URL$1.LOGIN
  }
};

var USER_TYPE = {
  RENTER: 'renter',
  AGENT: 'landlord',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin',
  READ_ONLY: 'read_only',
  ANONYMOUS: 'anonymous'
};

var _templateObject$1 = taggedTemplateLiteral(['\n  @import url("https://cdnjs.cloudflare.com/ajax/libs/simple-line-icons/2.4.1/css/simple-line-icons.css");\n  @import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600,700");\n  @import url(\'https://fonts.googleapis.com/css?family=Lato\');\n  body {\n    a {\n      text-decoration: none !important;\n    }\n    * {\n      box-sizing: border-box;\n    }\n  }\n'], ['\n  @import url("https://cdnjs.cloudflare.com/ajax/libs/simple-line-icons/2.4.1/css/simple-line-icons.css");\n  @import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600,700");\n  @import url(\'https://fonts.googleapis.com/css?family=Lato\');\n  body {\n    a {\n      text-decoration: none !important;\n    }\n    * {\n      box-sizing: border-box;\n    }\n  }\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n  font-family: Source Sans Pro, sans-serif, \'simple-line-icons\';\n  font-size: 14px;\n  height: 70px;\n  border-bottom: 1px solid ', ';\n  z-index: 1500;\n  padding: 0 30px;\n  background-color: ', ';\n  > .container {\n    height: 100%;\n  }\n\n  @media (max-width: 991px) {\n    padding: 0 20px;\n  }\n'], ['\n  font-family: Source Sans Pro, sans-serif, \'simple-line-icons\';\n  font-size: 14px;\n  height: 70px;\n  border-bottom: 1px solid ', ';\n  z-index: 1500;\n  padding: 0 30px;\n  background-color: ', ';\n  > .container {\n    height: 100%;\n  }\n\n  @media (max-width: 991px) {\n    padding: 0 20px;\n  }\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n  height: 100%;\n  display: flex;\n  align-items: center;\n  position: relative;\n  justify-content: space-between;\n'], ['\n  height: 100%;\n  display: flex;\n  align-items: center;\n  position: relative;\n  justify-content: space-between;\n']),
    _templateObject4 = taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n'], ['\n  display: flex;\n  justify-content: center;\n']),
    _templateObject5 = taggedTemplateLiteral(['\n  height: 48px;\n  display: flex;\n  align-items: center;\n  margin: 10px 10px 10px 0px;\n  img {\n    width: auto;\n    height: 100%;\n    ', ';\n  }\n  @media (max-width: 991px) {\n    ', ';\n  }\n'], ['\n  height: 48px;\n  display: flex;\n  align-items: center;\n  margin: 10px 10px 10px 0px;\n  img {\n    width: auto;\n    height: 100%;\n    ', ';\n  }\n  @media (max-width: 991px) {\n    ', ';\n  }\n']),
    _templateObject6 = taggedTemplateLiteral(['\n  padding: 0;\n  display: flex;\n  ', ';\n'], ['\n  padding: 0;\n  display: flex;\n  ', ';\n']),
    _templateObject7 = taggedTemplateLiteral(['\n  position: absolute;\n  top: 17px;\n  right: 0px;\n  align-items: center;\n  justify-content: space-between;\n  display: flex;\n'], ['\n  position: absolute;\n  top: 17px;\n  right: 0px;\n  align-items: center;\n  justify-content: space-between;\n  display: flex;\n']),
    _templateObject8 = taggedTemplateLiteral(['\n  margin: 0 15px;\n  color: ', ';\n  &:focus {\n    color: ', ';\n  }\n  &:hover {\n    color: rgba(51, 51, 51, 0.9);\n  }\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n'], ['\n  margin: 0 15px;\n  color: ', ';\n  &:focus {\n    color: ', ';\n  }\n  &:hover {\n    color: rgba(51, 51, 51, 0.9);\n  }\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n']),
    _templateObject9 = taggedTemplateLiteral(['\n  border-radius: 50px;\n  cursor: pointer;\n  height: 35px;\n  padding: 0 20px;\n  margin-left: 10px;\n  transition: all ease-in-out 0.2s;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  background-color: ', ';\n  border: 1px solid ', ';\n  font-weight: 600;\n  color: white;\n  &:hover {\n    color: white;\n    background-color: ', ';\n    border: 1px solid ', ';\n  }\n  &:focus {\n    color: white;\n  }\n  ', ';\n'], ['\n  border-radius: 50px;\n  cursor: pointer;\n  height: 35px;\n  padding: 0 20px;\n  margin-left: 10px;\n  transition: all ease-in-out 0.2s;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  background-color: ', ';\n  border: 1px solid ', ';\n  font-weight: 600;\n  color: white;\n  &:hover {\n    color: white;\n    background-color: ', ';\n    border: 1px solid ', ';\n  }\n  &:focus {\n    color: white;\n  }\n  ', ';\n']),
    _templateObject10 = taggedTemplateLiteral(['\n  border-radius: 50px;\n  cursor: pointer;\n  padding: 0 20px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 135px;\n  font-weight: 600;\n  &:hover {\n    background-color: ', ';\n  }\n  ', ';\n'], ['\n  border-radius: 50px;\n  cursor: pointer;\n  padding: 0 20px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 135px;\n  font-weight: 600;\n  &:hover {\n    background-color: ', ';\n  }\n  ', ';\n']),
    _templateObject11 = taggedTemplateLiteral(['\n  margin: 0 12px 0 0;\n  color: ', ';\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  word-break: keep-all;\n  > img {\n    margin-right: 10px;\n  }\n  &:hover {\n    opacity: 0.8;\n    color: ', ';\n  }\n  @media (max-width: 991px) {\n    display: none;\n  }\n'], ['\n  margin: 0 12px 0 0;\n  color: ', ';\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  word-break: keep-all;\n  > img {\n    margin-right: 10px;\n  }\n  &:hover {\n    opacity: 0.8;\n    color: ', ';\n  }\n  @media (max-width: 991px) {\n    display: none;\n  }\n']),
    _templateObject12 = taggedTemplateLiteral(['\n  color: ', ';\n  font-weight: 600;\n  word-break: keep-all;\n  ', ' &:hover {\n    color: ', ';\n  }\n'], ['\n  color: ', ';\n  font-weight: 600;\n  word-break: keep-all;\n  ', ' &:hover {\n    color: ', ';\n  }\n']),
    _templateObject13 = taggedTemplateLiteral(['\n  margin: 0 12px;\n  font: inherit;\n  background-color: transparent;\n  color: ', ';\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  padding: 0;\n  &:hover {\n    opacity: 0.8;\n    color: ', ';\n  }\n  @media (max-width: 991px) {\n    display: none;\n  }\n\n  img {\n    width: 20px;\n    height: 11px;\n    margin-right: 7px;\n  }\n  ', ';\n'], ['\n  margin: 0 12px;\n  font: inherit;\n  background-color: transparent;\n  color: ', ';\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  padding: 0;\n  &:hover {\n    opacity: 0.8;\n    color: ', ';\n  }\n  @media (max-width: 991px) {\n    display: none;\n  }\n\n  img {\n    width: 20px;\n    height: 11px;\n    margin-right: 7px;\n  }\n  ', ';\n']),
    _templateObject14 = taggedTemplateLiteral(['\n  cursor: pointer;\n  float: left;\n  margin-right: 10px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border: 1px solid ', ';\n  border-radius: 50px;\n  padding: 2px 16px;\n  height: 35px;\n  z-index: 1601;\n  color: ', ';\n  @media (min-width: 992px) {\n    display: none;\n  }\n  top: 17.5px;\n\n  position: ', ';\n\n  .icon-bar:nth-child(1) {\n    transform: ', ';\n  }\n\n  .icon-bar:nth-child(2) {\n    opacity: ', ';\n  }\n\n  .icon-bar:last-child {\n    transform: ', ';\n  }\n'], ['\n  cursor: pointer;\n  float: left;\n  margin-right: 10px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border: 1px solid ', ';\n  border-radius: 50px;\n  padding: 2px 16px;\n  height: 35px;\n  z-index: 1601;\n  color: ', ';\n  @media (min-width: 992px) {\n    display: none;\n  }\n  top: 17.5px;\n\n  position: ', ';\n\n  .icon-bar:nth-child(1) {\n    transform: ', ';\n  }\n\n  .icon-bar:nth-child(2) {\n    opacity: ', ';\n  }\n\n  .icon-bar:last-child {\n    transform: ', ';\n  }\n']),
    _templateObject15 = taggedTemplateLiteral(['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 5px 0;\n  span {\n    display: block;\n    width: 20px;\n    height: 2px;\n    margin: 2px 0;\n    border-radius: 1px;\n    background-color: ', ';\n    transition: transform 0.25s ease-in-out 0s, opacity 0.25s ease-in-out 0s;\n  }\n'], ['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 5px 0;\n  span {\n    display: block;\n    width: 20px;\n    height: 2px;\n    margin: 2px 0;\n    border-radius: 1px;\n    background-color: ', ';\n    transition: transform 0.25s ease-in-out 0s, opacity 0.25s ease-in-out 0s;\n  }\n']),
    _templateObject16 = taggedTemplateLiteral(['\n  margin-left: 10px;\n  font-size: 1em;\n  padding-top: 4px;\n  font-weight: 600;\n'], ['\n  margin-left: 10px;\n  font-size: 1em;\n  padding-top: 4px;\n  font-weight: 600;\n']);

var GLOBAL = styled.createGlobalStyle(_templateObject$1);

// language=SCSS prefix=dummy{ suffix=}
var Navbar = styled__default.div(_templateObject2$1, COLOR.lineGrey, COLOR.white);

// language=SCSS prefix=dummy{ suffix=}
var FlexContainer = styled__default.div(_templateObject3$1);

var notLoginLogo = styled.css(_templateObject4);

// language=SCSS prefix=dummy{ suffix=}
var LogoLink = styled__default.a(_templateObject5, function (props) {
  return props.fixHeight ? 'height: ' + props.fixHeight : '';
}, function (props) {
  return !props.isLogin ? notLoginLogo : 'display: none;';
});

// language=SCSS prefix=dummy{ suffix=}
var LeftMenu = styled__default.div(_templateObject6, function (props) {
  return !props.isLogin && 'width:100%;';
});

// language=SCSS prefix=dummy{ suffix=}
var RightMenu = styled__default.div(_templateObject7);

var ItemRight = styled__default.a(_templateObject8, COLOR.black, COLOR.black);
var ButtonBlue = styled__default.a(_templateObject9, COLOR.deepBlue, COLOR.deepBlue, COLOR.darkDeepBlue, COLOR.darkDeepBlue, function (props) {
  return !lodash_isempty(props.styles) && props.styles;
});
var ButtonBlueGradient = styled__default(gradient.BlueGradientButton)(_templateObject10, COLOR.darkDeepBlue, function (props) {
  return !lodash_isempty(props.styles) && props.styles;
});

var LinkDesktop = styled__default.a(_templateObject11, COLOR.textBlack, COLOR.textBlack);

var Link = styled__default.a(_templateObject12, COLOR.textBlack, function (props) {
  return props.margin && 'margin: ' + props.margin + ';';
}, COLOR.placeholderGrey);

var ImageIconButton = styled__default.button(_templateObject13, COLOR.textBlack, COLOR.textBlack, function (props) {
  return props.flex && '\n    display: flex;\n    align-items: center;\n    ';
});

// language=SCSS prefix=dummy{ suffix=}
var NavToggle = styled__default.span(_templateObject14, COLOR.textBlack, COLOR.textBlack, function (props) {
  return props.isOpen ? 'fixed' : 'absolute';
}, function (props) {
  return props.isOpen && 'translateY(6px) rotate(45deg)';
}, function (props) {
  return props.isOpen ? '0' : '1';
}, function (props) {
  return props.isOpen && 'translateY(-6px) rotate(-45deg)';
});
var NavHamburger = styled__default.span(_templateObject15, COLOR.textBlack);
var NavToggleText = styled__default.span(_templateObject16);

function BtnToggleMobile(props) {
  var isLogin = props.isLogin,
      showBadge = props.showBadge,
      background = props.background;


  if (!isLogin) return null;

  return React__default.createElement(
    NavToggle,
    props,
    React__default.createElement(
      NavHamburger,
      null,
      React__default.createElement('span', { className: 'icon-bar' }),
      React__default.createElement('span', { className: 'icon-bar' }),
      React__default.createElement('span', { className: 'icon-bar' })
    ),
    React__default.createElement(
      componentV2.BadgeOverlap,
      {
        showBadge: showBadge,
        content: '',
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        background: background,
        transform: 'translate(18px, -8px)',
        styles: '@media (min-width: 992px) {display: none;}'
      },
      React__default.createElement(
        NavToggleText,
        null,
        'Menu'
      )
    )
  );
}

function LinkDesktop$1(_ref) {
  var menu = _ref.menu;

  return React__default.createElement(
    LinkDesktop,
    { key: menu.id, href: menu.url, id: menu.id, target: menu.target },
    menu.img && React__default.createElement('img', { src: menu.img, alt: menu.text }),
    menu.text
  );
}

LinkDesktop$1.propTypes = {
  menu: PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string,
    target: PropTypes.string,
    img: PropTypes.string,
    text: PropTypes.string,
    notice: PropTypes.string
  }).isRequired
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1 = Array.isArray;

var isArray_1 = isArray$1;

/** Detect free variable `global` from Node.js. */
var freeGlobal$2 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$2;

/** Detect free variable `self`. */
var freeSelf$2 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$2 = _freeGlobal || freeSelf$2 || Function('return this')();

var _root = root$2;

/** Built-in value references. */
var Symbol$3 = _root.Symbol;

var _Symbol = Symbol$3;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$2.toString;

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$2.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$2 = objectProto$3.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$2(value) {
  return nativeObjectToString$2.call(value);
}

var _objectToString = objectToString$2;

/** `Object#toString` result references. */
var nullTag$1 = '[object Null]',
    undefinedTag$1 = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$2 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$1(value) {
  if (value == null) {
    return value === undefined ? undefinedTag$1 : nullTag$1;
  }
  return (symToStringTag$2 && symToStringTag$2 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag$1;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$1;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag$1);
}

var isSymbol_1 = isSymbol$1;

/** Used to match property names within property paths. */
var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp$1 = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$1(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$1;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$2(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$2;

/** `Object#toString` result references. */
var asyncTag$1 = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$2 = '[object GeneratorFunction]',
    proxyTag$1 = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$2 || tag == asyncTag$1 || tag == proxyTag$1;
}

var isFunction_1 = isFunction$2;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = _root['__core-js_shared__'];

var _coreJsData = coreJsData$1;

/** Used to detect methods masquerading as native. */
var maskSrcKey$1 = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey$1 && (maskSrcKey$1 in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$1(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$1;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$4 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative$1 = RegExp('^' +
  funcToString$2.call(hasOwnProperty$3).replace(reRegExpChar$1, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$1(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$1;

/* Built-in method references that are verified to be native. */
var nativeCreate$1 = _getNative(Object, 'create');

var _nativeCreate = nativeCreate$1;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$4.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$5.call(data, key);
}

var _hashHas = hashHas$1;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$2 : value;
  return this;
}

var _hashSet = hashSet$1;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = _hashClear;
Hash$1.prototype['delete'] = _hashDelete;
Hash$1.prototype.get = _hashGet;
Hash$1.prototype.has = _hashHas;
Hash$1.prototype.set = _hashSet;

var _Hash = Hash$1;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq$1(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$1(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$1;

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto$1.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$1.prototype.clear = _listCacheClear;
ListCache$1.prototype['delete'] = _listCacheDelete;
ListCache$1.prototype.get = _listCacheGet;
ListCache$1.prototype.has = _listCacheHas;
ListCache$1.prototype.set = _listCacheSet;

var _ListCache = ListCache$1;

/* Built-in method references that are verified to be native. */
var Map$2 = _getNative(_root, 'Map');

var _Map = Map$2;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$1(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$1;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$1.prototype.clear = _mapCacheClear;
MapCache$1.prototype['delete'] = _mapCacheDelete;
MapCache$1.prototype.get = _mapCacheGet;
MapCache$1.prototype.has = _mapCacheHas;
MapCache$1.prototype.set = _mapCacheSet;

var _MapCache = MapCache$1;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = _MapCache;

var memoize_1 = memoize$1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar$1 = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName$1, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString$1) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _baseToString = baseToString$1;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString$1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$1(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath$1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$1(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

var _toKey = toKey$1;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$1(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$1;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$2(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$2;

var hamburger = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20y%3D%222%22%20width%3D%2224%22%20height%3D%224%22%20fill%3D%22%23AAAAAA%22%2F%3E%3Crect%20y%3D%2210%22%20width%3D%2224%22%20height%3D%224%22%20fill%3D%22%23AAAAAA%22%2F%3E%3Crect%20y%3D%2218%22%20width%3D%2224%22%20height%3D%224%22%20fill%3D%22%23AAAAAA%22%2F%3E%3C%2Fsvg%3E";

var _templateObject$2 = taggedTemplateLiteral(['\n  cursor: pointer;\n  margin: 0 0 0 15px;\n  display: flex;\n  align-items: center;\n  @media (max-width: 991px) {\n    display: none;\n  }\n'], ['\n  cursor: pointer;\n  margin: 0 0 0 15px;\n  display: flex;\n  align-items: center;\n  @media (max-width: 991px) {\n    display: none;\n  }\n']),
    _templateObject2$2 = taggedTemplateLiteral(['\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n'], ['\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n']),
    _templateObject3$2 = taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n  margin-left: 15px;\n\n  @media (max-width: 991px) {\n    margin-left: 0;\n  }\n'], ['\n  display: flex;\n  justify-content: space-between;\n  margin-left: 15px;\n\n  @media (max-width: 991px) {\n    margin-left: 0;\n  }\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n  margin: 0px 0 0px 20px;\n  height: auto;\n'], ['\n  margin: 0px 0 0px 20px;\n  height: auto;\n']),
    _templateObject5$1 = taggedTemplateLiteral(['\n  border-left: 1px solid ', ';\n  height: auto;\n'], ['\n  border-left: 1px solid ', ';\n  height: auto;\n']),
    _templateObject6$1 = taggedTemplateLiteral(['\n  color: #333;\n  font-size: 1em;\n  font-weight: 600;\n  margin-left: 12px;\n'], ['\n  color: #333;\n  font-size: 1em;\n  font-weight: 600;\n  margin-left: 12px;\n']),
    _templateObject7$1 = taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 12px;\n  margin-left: 8px;\n  transform-origin: 50% 40%;\n  transition: transform 0.25s ease-in-out 0s;\n  transform: ', ';\n'], ['\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 12px;\n  margin-left: 8px;\n  transform-origin: 50% 40%;\n  transition: transform 0.25s ease-in-out 0s;\n  transform: ', ';\n']),
    _templateObject8$1 = taggedTemplateLiteral(['\n  position: absolute;\n  top: 62px;\n  right: 20px;\n  min-width: 190px;\n  background-color: ', ';\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);\n  border-radius: 5px;\n  transition: opacity 0.25s ease-in-out 0s;\n  z-index: 1600;\n  @media (max-width: 991px) {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    transform-origin: 100% 0;\n    transition: all 0.5s ease-in-out 0s;\n    overflow: hidden;\n    opacity: 1;\n    border: 0;\n    top: 0;\n    left: 0;\n    border-radius: 0;\n  }\n  .nav-hamburger {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    padding: 5px 0;\n  }\n  .nav-toggle-text {\n    margin-left: 10px;\n    font-size: 1em;\n    padding-top: 4px;\n  }\n\n  .icon-bar {\n    display: block;\n    width: 20px;\n    height: 2px;\n    margin: 2px 0;\n    border-radius: 1px;\n    background-color: ', ';\n    transition: transform 0.25s ease-in-out 0s, opacity 0.25s ease-in-out 0s;\n  }\n  animation: fade-in 0.5s;\n  @keyframes fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n'], ['\n  position: absolute;\n  top: 62px;\n  right: 20px;\n  min-width: 190px;\n  background-color: ', ';\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);\n  border-radius: 5px;\n  transition: opacity 0.25s ease-in-out 0s;\n  z-index: 1600;\n  @media (max-width: 991px) {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    transform-origin: 100% 0;\n    transition: all 0.5s ease-in-out 0s;\n    overflow: hidden;\n    opacity: 1;\n    border: 0;\n    top: 0;\n    left: 0;\n    border-radius: 0;\n  }\n  .nav-hamburger {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    padding: 5px 0;\n  }\n  .nav-toggle-text {\n    margin-left: 10px;\n    font-size: 1em;\n    padding-top: 4px;\n  }\n\n  .icon-bar {\n    display: block;\n    width: 20px;\n    height: 2px;\n    margin: 2px 0;\n    border-radius: 1px;\n    background-color: ', ';\n    transition: transform 0.25s ease-in-out 0s, opacity 0.25s ease-in-out 0s;\n  }\n  animation: fade-in 0.5s;\n  @keyframes fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n']),
    _templateObject9$1 = taggedTemplateLiteral(['\n  display: ', ';\n  list-style: none;\n  margin: 0;\n  padding: 5px 0;\n  width: 168px;\n  @media (max-width: 991px) {\n    position: fixed;\n    overflow-y: auto;\n    width: 100%;\n    top: 70px;\n    bottom: 0;\n    border-top: 1px solid #ddd;\n    padding-top: 10px;\n  }\n'], ['\n  display: ', ';\n  list-style: none;\n  margin: 0;\n  padding: 5px 0;\n  width: 168px;\n  @media (max-width: 991px) {\n    position: fixed;\n    overflow-y: auto;\n    width: 100%;\n    top: 70px;\n    bottom: 0;\n    border-top: 1px solid #ddd;\n    padding-top: 10px;\n  }\n']),
    _templateObject10$1 = taggedTemplateLiteral(['\n  cursor: pointer;\n  font-weight: normal;\n\n  &.hideDeskTop {\n    display: none;\n    @media (max-width: 991px) {\n      display: block;\n    }\n  }\n\n  &.hideImgMobile {\n    a,\n    button {\n      img {\n        display: none;\n      }\n    }\n  }\n\n  a,\n  button {\n    width: 100%;\n    min-width: 190px;\n    display: flex;\n    align-items: center;\n    color: ', ';\n    padding: 8px 15px;\n    cursor: pointer;\n    transition: all 0.25s ease-in-out 0s;\n\n    &:hover {\n      background-color: ', ';\n    }\n    img {\n      height: 35px;\n      width: 35px;\n      position: relative;\n      top: 2px;\n      color: black;\n      ', ' border-radius: 50%;\n      ', ';\n\n      @media (min-width: 991px) {\n        min-width: 35px;\n        min-height: 35px;\n      }\n    }\n    span {\n      margin-left: 10px;\n    }\n    i {\n      font-size: 16px;\n    }\n\n    @media (max-width: 991px) {\n      padding: 10px 25px;\n      font-weight: 600;\n      font-size: 16px;\n      border-radius: 0;\n\n      i {\n        ', ';\n      }\n\n      &:hover {\n        padding-left: 30px;\n      }\n    }\n  }\n'], ['\n  cursor: pointer;\n  font-weight: normal;\n\n  &.hideDeskTop {\n    display: none;\n    @media (max-width: 991px) {\n      display: block;\n    }\n  }\n\n  &.hideImgMobile {\n    a,\n    button {\n      img {\n        display: none;\n      }\n    }\n  }\n\n  a,\n  button {\n    width: 100%;\n    min-width: 190px;\n    display: flex;\n    align-items: center;\n    color: ', ';\n    padding: 8px 15px;\n    cursor: pointer;\n    transition: all 0.25s ease-in-out 0s;\n\n    &:hover {\n      background-color: ', ';\n    }\n    img {\n      height: 35px;\n      width: 35px;\n      position: relative;\n      top: 2px;\n      color: black;\n      ', ' border-radius: 50%;\n      ', ';\n\n      @media (min-width: 991px) {\n        min-width: 35px;\n        min-height: 35px;\n      }\n    }\n    span {\n      margin-left: 10px;\n    }\n    i {\n      font-size: 16px;\n    }\n\n    @media (max-width: 991px) {\n      padding: 10px 25px;\n      font-weight: 600;\n      font-size: 16px;\n      border-radius: 0;\n\n      i {\n        ', ';\n      }\n\n      &:hover {\n        padding-left: 30px;\n      }\n    }\n  }\n']),
    _templateObject11$1 = taggedTemplateLiteral(['\n  display: block;\n  margin: 10px;\n  height: 1px;\n  background-color: rgba(0, 0, 0, 0.1);\n  @media (min-width: 991px) {\n    width: 100%;\n  }\n'], ['\n  display: block;\n  margin: 10px;\n  height: 1px;\n  background-color: rgba(0, 0, 0, 0.1);\n  @media (min-width: 991px) {\n    width: 100%;\n  }\n']),
    _templateObject12$1 = taggedTemplateLiteral(['\n  height: 16px;\n  width: 16px;\n'], ['\n  height: 16px;\n  width: 16px;\n']),
    _templateObject13$1 = taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n'], ['\n  display: flex;\n  flex-direction: column;\n']),
    _templateObject14$1 = taggedTemplateLiteral(['\n  ', '\n  @media (max-width: 991px) {\n    ', '\n    ', '\n    font-weight: ', ';\n  }\n'], ['\n  ', '\n  @media (max-width: 991px) {\n    ', '\n    ', '\n    font-weight: ', ';\n  }\n']);

// language=SCSS prefix=dummy{ suffix=}
var DropdownToggle = styled__default.span(_templateObject$2);

var ToggleImg = styled__default.img(_templateObject2$2);
var MenuProfile = styled__default.span(_templateObject3$2);

var NavbarHamburger = styled__default.img(_templateObject4$1);
var VerticalLine = styled__default.div(_templateObject5$1, COLOR.lineGrey);

var ToggleText = styled__default.span(_templateObject6$1);
var ToggleIcon = styled__default.span(_templateObject7$1, function (props) {
  return props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
});

// language=SCSS prefix=dummy{ suffix=}
var Dropdown = styled__default.span(_templateObject8$1, COLOR.white, COLOR.black);

// language=SCSS prefix=dummy{ suffix=}
var DropdownMenuList = styled__default.ul(_templateObject9$1, function (props) {
  return props.isOpen ? 'block' : 'none';
});

// language=SCSS prefix=dummy{ suffix=}
var DropdownMenuItem = styled__default.li(_templateObject10$1, COLOR.textBlack, COLOR.bgGrey, function (props) {
  return !props.noIconFilter && 'filter: invert(1);';
}, function (props) {
  return props.showMobileIcon && 'margin-left: 10px; width: 16px; height: 16px;';
}, function (props) {
  return props.showMobileIcon && '\n          display: none;\n          margin-left: 10px;\n        ';
});

var Divider = styled__default.div(_templateObject11$1);

var IconWrapper = styled__default.div(_templateObject12$1);

var ClaimProfileWrapper = styled__default.div(_templateObject13$1);

var ClaimText = styled__default.span(_templateObject14$1, function (props) {
  return props.hideDesktop && 'display: none;';
}, function (props) {
  return props.link && 'color: ' + COLOR.deepBlueLight + ';';
}, function (props) {
  return props.hideDesktop && 'display: inline;';
}, function (props) {
  return props.weight ? props.weight : '400';
});

/**
 * @private
 * Menu item for each dropdown item component
 * @param {object} props
 * @param {Partial<{
 *  readonly badgeStyle: object,
 *  readonly icon: string,
 *  readonly id: string,
 *  readonly img: string
 *  readonly isDivider: boolean,
 *  readonly isMobileReloaded: boolean,
 *  readonly notice: string,
 *  readonly onClick: React.MouseEventHandler<HTMLAnchorElement>,
 *  readonly showBadge: string,
 *  readonly target: React.HTMLAttributeAnchorTarget
 *  readonly text: string,
 *  readonly url: string,
 * }>} props.menu menu information e.g. url, id and etc
 */
function MenuItem(_ref) {
  var menu = _ref.menu;

  return React__default.createElement(
    React.Fragment,
    null,
    React__default.createElement(
      componentV2.BadgeOverlap,
      _extends({ showBadge: menu.showBadge }, menu.badgeStyle),
      menu.img ? React__default.createElement('img', { src: menu.img, alt: menu.text }) : React__default.createElement(
        IconWrapper,
        null,
        React__default.createElement('i', { className: menu.icon })
      )
    ),
    React__default.createElement(
      'span',
      null,
      menu.text
    )
  );
}

/**
 * Dropdown item component;
 * client will use either <a> tag or <Link> tag
 * to depend on `isMobileReloaded` flag simply because
 * on certain URL, client should redirect instead
 * of reloading only section of body content
 * @param {object} props
 * @param {string} props.index key that uses to indicate index of menu
 * @param {string} props.key key that uses to render in each dropdown menu item
 * @param {Partial<{
 *  readonly badgeStyle: object,
 *  readonly icon: string,
 *  readonly id: string,
 *  readonly img: string
 *  readonly isDivider: boolean,
 *  readonly isMobileReloaded: boolean,
 *  readonly notice: string,
 *  readonly onClick: React.MouseEventHandler<HTMLAnchorElement>,
 *  readonly showBadge: string,
 *  readonly target: React.HTMLAttributeAnchorTarget
 *  readonly text: string,
 *  readonly url: string,
 * }>} props.menu menu information e.g. url, id and etc
 */
function DropdownItem(_ref2) {
  var index = _ref2.index,
      key = _ref2.key,
      menu = _ref2.menu;

  return React__default.createElement(
    DropdownMenuItem,
    {
      key: key,
      className: menu.className,
      showMobileIcon: menu.showMobileIcon,
      noIconFilter: menu.noIconFilter
    },
    menu.isMobileReloaded ? React__default.createElement(
      reactRouterDom.Link,
      { index: index, to: menu.url, onClick: menu.onClick, id: menu.id },
      React__default.createElement(MenuItem, { menu: menu })
    ) : React__default.createElement(
      'a',
      { index: index, href: menu.url, onClick: menu.onClick, id: menu.id, target: menu.target },
      React__default.createElement(MenuItem, { menu: menu })
    ),
    menu.isDivider && React__default.createElement(Divider, { key: 'divider' })
  );
}

var OutsideClickHandler = function (_React$Component) {
  inherits(OutsideClickHandler, _React$Component);

  function OutsideClickHandler(props) {
    classCallCheck(this, OutsideClickHandler);

    var _this = possibleConstructorReturn(this, (OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call(this, props));

    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    return _this;
  }

  createClass(OutsideClickHandler, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickOutside, {
        capture: true
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside, {
        capture: true
      });
    }

    /**
     * Set the wrapper ref
     */

  }, {
    key: 'setWrapperRef',
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }

    /**
     * Alert if clicked on outside of element
     */

  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(event) {
      var handleOutsideClick = this.props.handleOutsideClick;

      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        handleOutsideClick(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return React__default.createElement(
        'div',
        { ref: this.setWrapperRef },
        children
      );
    }
  }]);
  return OutsideClickHandler;
}(React__default.Component);

/* eslint-disable jsx-a11y/click-events-have-key-events */

function MenuProfile$1(props) {
  var handleToggleNav = props.handleToggleNav,
      profile = props.profile,
      toggleMobile = props.toggleMobile,
      listMenu = props.listMenu;

  var firstName = get_1(profile, 'firstName');
  var userType = get_1(profile, 'userType', USER_TYPE.RENTER);

  return React__default.createElement(
    MenuProfile,
    { id: 'profile' },
    React__default.createElement(VerticalLine, null),
    React__default.createElement(
      DropdownToggle,
      { id: 'profileDropdownToggle', onClick: handleToggleNav },
      firstName && React__default.createElement(
        ToggleText,
        { id: 'profileToggleText' },
        'Hi, ' + firstName
      ),
      React__default.createElement(NavbarHamburger, { src: hamburger, alt: 'hamburger' })
    ),
    toggleMobile.isOpen && React__default.createElement(
      OutsideClickHandler,
      { handleOutsideClick: handleToggleNav },
      React__default.createElement(
        Dropdown,
        {
          id: 'profileDropdown',
          isOpen: toggleMobile.isOpen,
          onClick: handleToggleNav
        },
        React__default.createElement(
          DropdownMenuList,
          { id: 'profileDropdownMenuList', isOpen: toggleMobile.isOpen },
          listMenu[userType] && listMenu[userType].map(function (menu, index) {
            return React__default.createElement(DropdownItem, { index: index, key: menu.id, menu: menu });
          })
        )
      )
    )
  );
}

/* eslint-disable jsx-a11y/alt-text */

var LogoExternalIntegration = function (_React$Component) {
  inherits(LogoExternalIntegration, _React$Component);

  function LogoExternalIntegration() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, LogoExternalIntegration);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = LogoExternalIntegration.__proto__ || Object.getPrototypeOf(LogoExternalIntegration)).call.apply(_ref, [this].concat(args))), _this), _this.state = { imgLoadFailed: false }, _this.handleOnError = function () {
      return _this.setState({ imgLoadFailed: true });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(LogoExternalIntegration, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          partnerLogoSrc = _props.partnerLogoSrc,
          isLogin = _props.isLogin;
      var imgLoadFailed = this.state.imgLoadFailed;

      return partnerLogoSrc && !imgLoadFailed ? React__default.createElement(
        LogoLink,
        { isLogin: isLogin, href: URL$1.DASHBOARD },
        React__default.createElement('img', { src: partnerLogoSrc, onError: this.handleOnError })
      ) : null;
    }
  }]);
  return LogoExternalIntegration;
}(React__default.Component);

function Navbar$1(props) {
  var _this = this;

  var showGenericSurvey = props.showGenericSurvey,
      handleApiErrors = props.handleApiErrors,
      isShowRenterSupport = props.isShowRenterSupport,
      handleLogout = props.handleLogout,
      message = props.message,
      changeUserType = props.changeUserType,
      profile = props.profile,
      partnerLogoSrc = props.partnerLogoSrc,
      isShowSupport = props.isShowSupport,
      tracker = props.tracker,
      _props$profileBadgeSt = props.profileBadgeStyle,
      profileBadgeStyle = _props$profileBadgeSt === undefined ? {} : _props$profileBadgeSt,
      _props$otherButton = props.otherButton,
      otherButton = _props$otherButton === undefined ? {} : _props$otherButton;


  var userType = lodash_get(profile, 'userType');

  var _useState = React.useState({ isOpen: false }),
      _useState2 = slicedToArray(_useState, 2),
      toggleMobile = _useState2[0],
      setToggleMobile = _useState2[1];

  var handleShowSurveyError = React.useCallback(function (err) {
    if (handleApiErrors) handleApiErrors(err);else if (err && err.status === 401) {
      cookie.removeLocalItem(STORAGE.USER_TOKEN);
      window.location.assign(URL$1.LOGIN);
    }
  }, [handleApiErrors]);

  var onShowFeedbackSurvey = React.useCallback(asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return showGenericSurvey();

          case 3:
            _context.next = 8;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context['catch'](0);

            handleShowSurveyError(lodash_get(_context.t0, 'response', _context.t0));

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 5]]);
  })), [showGenericSurvey, handleShowSurveyError]);

  // handle toggle side effect
  React.useEffect(function () {
    if (toggleMobile.isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [toggleMobile]);

  // build menu and otherMenu

  var _useMemo = React.useMemo(function () {
    var messageMenu = [];
    if (message) messageMenu = [_extends({}, MENU.MESSAGING, { notice: message.notice })];
    var MENU_SUPPORT = isShowRenterSupport ? MENU.SUPPORT_RENTER : MENU.SUPPORT;

    var buildingMenu = {};

    buildingMenu[USER_TYPE.ANONYMOUS] = [MENU.LOGIN];

    buildingMenu[USER_TYPE.AGENT] = [MENU.PROFILE, _extends({}, MENU.FEEDBACK, { onClick: onShowFeedbackSurvey }), MENU.SUPPORT, _extends({}, MENU.LOGOUT, { onClick: handleLogout }), _extends({}, MENU.SWITCH_RENTER, {
      onClick: function onClick() {
        return changeUserType(USER_TYPE.RENTER);
      }
    })];

    buildingMenu[USER_TYPE.RENTER] = [].concat(toConsumableArray(messageMenu), [MENU.PROFILE, MENU_SUPPORT, _extends({}, MENU.LOGOUT, { onClick: handleLogout }), _extends({}, MENU.SWITCH_AGENT, {
      onClick: function onClick() {
        return changeUserType(USER_TYPE.AGENT);
      }
    })]);

    return { menu: buildingMenu, otherMenu: [].concat(toConsumableArray(messageMenu), [MENU_SUPPORT]) };
  }, [message, isShowRenterSupport, handleLogout, changeUserType, onShowFeedbackSurvey]),
      menu = _useMemo.menu,
      otherMenu = _useMemo.otherMenu;

  // build propsButton


  var propsButton = React.useMemo(function () {
    var onClick = otherButton.onClick,
        url = otherButton.url,
        styles = otherButton.styles,
        id = otherButton.id;

    var propsOtherButton = { styles: styles, id: id };

    propsOtherButton.onClick = lodash_isfunction(onClick) ? onClick : function () {
      return redirect(url || generateUrlByUserType(userType));
    };
    return propsOtherButton;
  }, [otherButton, userType]);

  var handleToggleNav = function handleToggleNav(e) {
    e.stopPropagation();
    setToggleMobile({ isOpen: !toggleMobile.isOpen });
  };

  var isLogin = !lodash_isempty(lodash_get(profile, 'email'));

  var MENU_SUPPORT = isShowRenterSupport ? MENU.SUPPORT_RENTER : MENU.SUPPORT;

  return React__default.createElement(
    Navbar,
    { id: 'navbar' },
    React__default.createElement(GLOBAL, null),
    React__default.createElement(HubspotFormCSS, null),
    React__default.createElement(
      FlexContainer,
      { id: 'navbarFlexContainer' },
      React__default.createElement(
        LeftMenu,
        { id: 'navbarLogo', isLogin: isLogin },
        React__default.createElement(
          LogoLink,
          { isLogin: isLogin, id: 'navbarLogoLink', href: URL$1.DASHBOARD },
          React__default.createElement('img', {
            src: RENTSPREE_NAVBAR_LOGO_URL,
            style: { maxHeight: '32px' },
            alt: 'Rentspree Logo'
          })
        ),
        React__default.createElement(LogoExternalIntegration, { partnerLogoSrc: partnerLogoSrc, isLogin: isLogin }),
        React__default.createElement(BtnToggleMobile, {
          id: 'mMenuToggleBtn',
          onClick: handleToggleNav,
          isOpen: toggleMobile.isOpen,
          isLogin: isLogin
        })
      ),
      isLogin ? React__default.createElement(
        RightMenu,
        null,
        userType === USER_TYPE.AGENT && React__default.createElement(
          ImageIconButton,
          { onClick: onShowFeedbackSurvey, flex: true },
          React__default.createElement('img', { src: feedbackImg, alt: 'Rentspree Feedback' }),
          'Give Feedback'
        ),
        otherMenu.map(function (item) {
          return React__default.createElement(LinkDesktop$1, { key: item.id, menu: item });
        }),
        otherButton && React__default.createElement(
          ButtonBlueGradient,
          _extends({}, propsButton, { id: propsButton.id || 'other-button' }),
          otherButton.text || 'My Dashboard'
        ),
        React__default.createElement(MenuProfile$1, {
          profile: profile,
          listMenu: menu,
          handleToggleNav: handleToggleNav,
          toggleMobile: toggleMobile,
          tracker: tracker,
          profileBadgeStyle: profileBadgeStyle
        })
      ) : React__default.createElement(
        FlexContainer,
        { id: 'navbarFlexContainer' },
        isShowSupport && React__default.createElement(
          Link,
          {
            key: MENU_SUPPORT.id,
            href: MENU_SUPPORT.url,
            id: MENU_SUPPORT.id,
            margin: '0 12px 0 0',
            target: MENU_SUPPORT.target
          },
          MENU_SUPPORT.text
        ),
        menu[USER_TYPE.ANONYMOUS].map(function (item) {
          return React__default.createElement(LinkDesktop$1, { key: item.id, menu: item });
        }),
        otherButton && React__default.createElement(
          ButtonBlueGradient,
          _extends({}, propsButton, { id: propsButton.id || 'other-button' }),
          otherButton.text || 'GET STARTED'
        )
      )
    )
  );
}

Navbar$1.propTypes = {
  /** otherButton object */
  /*
   * {
   * text: "Dashboard",
   * url: "http://",
   * onClick:, Function,
   * styles: "css"
   * }
   */
  otherButton: PropTypes.object,

  /** profile object */
  profile: PropTypes.object.isRequired,

  /** function change user type */
  changeUserType: PropTypes.func,

  /** function logout */
  handleLogout: PropTypes.func,

  /** otherMenu object */
  /*
   * [{
   * url: URL.SUPPORT_URL,
   * text: "Support",
   * id: "navSupport",
   * target: "_blank",
   * className: "hideDeskTop",
   * isDivider: true
   * }]
   */
  otherMenu: PropTypes.object,

  /** message object */
  /*
   * {
   * notice: 10
   * }
   */
  message: PropTypes.object,

  /** partner's logo path in string */
  partnerLogoSrc: PropTypes.string,

  /** isShowSupport */
  /*
   * if this value is true,
   * will show Support by default when user not login
   */
  isShowSupport: PropTypes.bool,

  /**
   * Custom API Configuration Object
   */
  configApi: PropTypes.object,

  /** isShowSupport */
  /*
   * if this value is true,
   * will change support link to support renter
   */
  isShowRenterSupport: PropTypes.bool,
  profileBadgeStyle: PropTypes.object,
  handleShowSurveyError: PropTypes.func
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function e(e,t){var i={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.indexOf(o)<0&&(i[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(o=Object.getOwnPropertySymbols(e);n<o.length;n++)t.indexOf(o[n])<0&&Object.prototype.propertyIsEnumerable.call(e,o[n])&&(i[o[n]]=e[o[n]]);}return i}var t="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function i(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}function o(e,t){return e(t={exports:{}},t.exports),t.exports}var n=o((function(e,t){Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(){var e=this;this.locked=new Map,this.addToLocked=function(t,i){var o=e.locked.get(t);void 0===o?void 0===i?e.locked.set(t,[]):e.locked.set(t,[i]):void 0!==i&&(o.unshift(i),e.locked.set(t,o));},this.isLocked=function(t){return e.locked.has(t)},this.lock=function(t){return new Promise((function(i,o){e.isLocked(t)?e.addToLocked(t,i):(e.addToLocked(t),i());}))},this.unlock=function(t){var i=e.locked.get(t);if(void 0!==i&&0!==i.length){var o=i.pop();e.locked.set(t,i),void 0!==o&&setTimeout(o,0);}else e.locked.delete(t);};}return e.getInstance=function(){return void 0===e.instance&&(e.instance=new e),e.instance},e}();t.default=function(){return i.getInstance()};}));i(n);var a=i(o((function(e,i){var o=t&&t.__awaiter||function(e,t,i,o){return new(i||(i=Promise))((function(n,a){function r(e){try{c(o.next(e));}catch(e){a(e);}}function s(e){try{c(o.throw(e));}catch(e){a(e);}}function c(e){e.done?n(e.value):new i((function(t){t(e.value);})).then(r,s);}c((o=o.apply(e,t||[])).next());}))},a=t&&t.__generator||function(e,t){var i,o,n,a,r={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return a={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(a[Symbol.iterator]=function(){return this}),a;function s(a){return function(s){return function(a){if(i)throw new TypeError("Generator is already executing.");for(;r;)try{if(i=1,o&&(n=2&a[0]?o.return:a[0]?o.throw||((n=o.return)&&n.call(o),0):o.next)&&!(n=n.call(o,a[1])).done)return n;switch(o=0,n&&(a=[2&a[0],n.value]),a[0]){case 0:case 1:n=a;break;case 4:return r.label++,{value:a[1],done:!1};case 5:r.label++,o=a[1],a=[0];continue;case 7:a=r.ops.pop(),r.trys.pop();continue;default:if(!(n=r.trys,(n=n.length>0&&n[n.length-1])||6!==a[0]&&2!==a[0])){r=0;continue}if(3===a[0]&&(!n||a[1]>n[0]&&a[1]<n[3])){r.label=a[1];break}if(6===a[0]&&r.label<n[1]){r.label=n[1],n=a;break}if(n&&r.label<n[2]){r.label=n[2],r.ops.push(a);break}n[2]&&r.ops.pop(),r.trys.pop();continue}a=t.call(e,r);}catch(e){a=[6,e],o=0;}finally{i=n=0;}if(5&a[0])throw a[1];return {value:a[0]?a[1]:void 0,done:!0}}([a,s])}}},r=t;Object.defineProperty(i,"__esModule",{value:!0});var s="browser-tabs-lock-key",c={key:function(e){return o(r,void 0,void 0,(function(){return a(this,(function(e){throw new Error("Unsupported")}))}))},getItem:function(e){return o(r,void 0,void 0,(function(){return a(this,(function(e){throw new Error("Unsupported")}))}))},clear:function(){return o(r,void 0,void 0,(function(){return a(this,(function(e){return [2,window.localStorage.clear()]}))}))},removeItem:function(e){return o(r,void 0,void 0,(function(){return a(this,(function(e){throw new Error("Unsupported")}))}))},setItem:function(e,t){return o(r,void 0,void 0,(function(){return a(this,(function(e){throw new Error("Unsupported")}))}))},keySync:function(e){return window.localStorage.key(e)},getItemSync:function(e){return window.localStorage.getItem(e)},clearSync:function(){return window.localStorage.clear()},removeItemSync:function(e){return window.localStorage.removeItem(e)},setItemSync:function(e,t){return window.localStorage.setItem(e,t)}};function d(e){return new Promise((function(t){return setTimeout(t,e)}))}function u(e){for(var t="0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz",i="",o=0;o<e;o++){i+=t[Math.floor(Math.random()*t.length)];}return i}var l=function(){function e(t){this.acquiredIatSet=new Set,this.storageHandler=void 0,this.id=Date.now().toString()+u(15),this.acquireLock=this.acquireLock.bind(this),this.releaseLock=this.releaseLock.bind(this),this.releaseLock__private__=this.releaseLock__private__.bind(this),this.waitForSomethingToChange=this.waitForSomethingToChange.bind(this),this.refreshLockWhileAcquired=this.refreshLockWhileAcquired.bind(this),this.storageHandler=t,void 0===e.waiters&&(e.waiters=[]);}return e.prototype.acquireLock=function(t,i){return void 0===i&&(i=5e3),o(this,void 0,void 0,(function(){var o,n,r,l,h,p,m;return a(this,(function(a){switch(a.label){case 0:o=Date.now()+u(4),n=Date.now()+i,r=s+"-"+t,l=void 0===this.storageHandler?c:this.storageHandler,a.label=1;case 1:return Date.now()<n?[4,d(30)]:[3,8];case 2:return a.sent(),null!==l.getItemSync(r)?[3,5]:(h=this.id+"-"+t+"-"+o,[4,d(Math.floor(25*Math.random()))]);case 3:return a.sent(),l.setItemSync(r,JSON.stringify({id:this.id,iat:o,timeoutKey:h,timeAcquired:Date.now(),timeRefreshed:Date.now()})),[4,d(30)];case 4:return a.sent(),null!==(p=l.getItemSync(r))&&(m=JSON.parse(p)).id===this.id&&m.iat===o?(this.acquiredIatSet.add(o),this.refreshLockWhileAcquired(r,o),[2,!0]):[3,7];case 5:return e.lockCorrector(void 0===this.storageHandler?c:this.storageHandler),[4,this.waitForSomethingToChange(n)];case 6:a.sent(),a.label=7;case 7:return o=Date.now()+u(4),[3,1];case 8:return [2,!1]}}))}))},e.prototype.refreshLockWhileAcquired=function(e,t){return o(this,void 0,void 0,(function(){var i=this;return a(this,(function(r){return setTimeout((function(){return o(i,void 0,void 0,(function(){var i,o,r;return a(this,(function(a){switch(a.label){case 0:return [4,n.default().lock(t)];case 1:return a.sent(),this.acquiredIatSet.has(t)?(i=void 0===this.storageHandler?c:this.storageHandler,null===(o=i.getItemSync(e))?(n.default().unlock(t),[2]):((r=JSON.parse(o)).timeRefreshed=Date.now(),i.setItemSync(e,JSON.stringify(r)),n.default().unlock(t),this.refreshLockWhileAcquired(e,t),[2])):(n.default().unlock(t),[2])}}))}))}),1e3),[2]}))}))},e.prototype.waitForSomethingToChange=function(t){return o(this,void 0,void 0,(function(){return a(this,(function(i){switch(i.label){case 0:return [4,new Promise((function(i){var o=!1,n=Date.now(),a=!1;function r(){if(a||(window.removeEventListener("storage",r),e.removeFromWaiting(r),clearTimeout(s),a=!0),!o){o=!0;var t=50-(Date.now()-n);t>0?setTimeout(i,t):i(null);}}window.addEventListener("storage",r),e.addToWaiting(r);var s=setTimeout(r,Math.max(0,t-Date.now()));}))];case 1:return i.sent(),[2]}}))}))},e.addToWaiting=function(t){this.removeFromWaiting(t),void 0!==e.waiters&&e.waiters.push(t);},e.removeFromWaiting=function(t){void 0!==e.waiters&&(e.waiters=e.waiters.filter((function(e){return e!==t})));},e.notifyWaiters=function(){void 0!==e.waiters&&e.waiters.slice().forEach((function(e){return e()}));},e.prototype.releaseLock=function(e){return o(this,void 0,void 0,(function(){return a(this,(function(t){switch(t.label){case 0:return [4,this.releaseLock__private__(e)];case 1:return [2,t.sent()]}}))}))},e.prototype.releaseLock__private__=function(t){return o(this,void 0,void 0,(function(){var i,o,r,d;return a(this,(function(a){switch(a.label){case 0:return i=void 0===this.storageHandler?c:this.storageHandler,o=s+"-"+t,null===(r=i.getItemSync(o))?[2]:(d=JSON.parse(r)).id!==this.id?[3,2]:[4,n.default().lock(d.iat)];case 1:a.sent(),this.acquiredIatSet.delete(d.iat),i.removeItemSync(o),n.default().unlock(d.iat),e.notifyWaiters(),a.label=2;case 2:return [2]}}))}))},e.lockCorrector=function(t){for(var i=Date.now()-5e3,o=t,n=[],a=0;;){var r=o.keySync(a);if(null===r)break;n.push(r),a++;}for(var c=!1,d=0;d<n.length;d++){var u=n[d];if(u.includes(s)){var l=o.getItemSync(u);if(null!==l){var h=JSON.parse(l);(void 0===h.timeRefreshed&&h.timeAcquired<i||void 0!==h.timeRefreshed&&h.timeRefreshed<i)&&(o.removeItemSync(u),c=!0);}}}c&&e.notifyWaiters();},e.waiters=void 0,e}();i.default=l;})));const r={timeoutInSeconds:60},s={name:"auth0-spa-js",version:"2.1.3"},c=()=>Date.now();class d extends Error{constructor(e,t){super(t),this.error=e,this.error_description=t,Object.setPrototypeOf(this,d.prototype);}static fromPayload({error:e,error_description:t}){return new d(e,t)}}class u extends d{constructor(e,t,i,o=null){super(e,t),this.state=i,this.appState=o,Object.setPrototypeOf(this,u.prototype);}}class l extends d{constructor(){super("timeout","Timeout"),Object.setPrototypeOf(this,l.prototype);}}class h extends l{constructor(e){super(),this.popup=e,Object.setPrototypeOf(this,h.prototype);}}class p extends d{constructor(e){super("cancelled","Popup closed"),this.popup=e,Object.setPrototypeOf(this,p.prototype);}}class m extends d{constructor(e,t,i){super(e,t),this.mfa_token=i,Object.setPrototypeOf(this,m.prototype);}}class f extends d{constructor(e,t){super("missing_refresh_token",`Missing Refresh Token (audience: '${g(e,["default"])}', scope: '${g(t)}')`),this.audience=e,this.scope=t,Object.setPrototypeOf(this,f.prototype);}}function g(e,t=[]){return e&&!t.includes(e)?e:""}const w=()=>window.crypto,y=()=>{const e="0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";let t="";return Array.from(w().getRandomValues(new Uint8Array(43))).forEach((i=>t+=e[i%e.length])),t},k=e=>btoa(e),v=t=>{var{clientId:i}=t,o=e(t,["clientId"]);return new URLSearchParams((e=>Object.keys(e).filter((t=>void 0!==e[t])).reduce(((t,i)=>Object.assign(Object.assign({},t),{[i]:e[i]})),{}))(Object.assign({client_id:i},o))).toString()},b=e=>(e=>decodeURIComponent(atob(e).split("").map((e=>"%"+("00"+e.charCodeAt(0).toString(16)).slice(-2))).join("")))(e.replace(/_/g,"/").replace(/-/g,"+")),_=async(e,t)=>{const i=await fetch(e,t);return {ok:i.ok,json:await i.json()}},I=async(e,t,i)=>{const o=new AbortController;let n;return t.signal=o.signal,Promise.race([_(e,t),new Promise(((e,t)=>{n=setTimeout((()=>{o.abort(),t(new Error("Timeout when executing 'fetch'"));}),i);}))]).finally((()=>{clearTimeout(n);}))},S=async(e,t,i,o,n,a,r)=>{return s={auth:{audience:t,scope:i},timeout:n,fetchUrl:e,fetchOptions:o,useFormData:r},c=a,new Promise((function(e,t){const i=new MessageChannel;i.port1.onmessage=function(o){o.data.error?t(new Error(o.data.error)):e(o.data),i.port1.close();},c.postMessage(s,[i.port2]);}));var s,c;},O=async(e,t,i,o,n,a,r=1e4)=>n?S(e,t,i,o,r,n,a):I(e,o,r);async function T(t,i){var{baseUrl:o,timeout:n,audience:a,scope:r,auth0Client:c,useFormData:u}=t,l=e(t,["baseUrl","timeout","audience","scope","auth0Client","useFormData"]);const h=u?v(l):JSON.stringify(l);return await async function(t,i,o,n,a,r,s){let c,u=null;for(let e=0;e<3;e++)try{c=await O(t,o,n,a,r,s,i),u=null;break}catch(e){u=e;}if(u)throw u;const l=c.json,{error:h,error_description:p}=l,g=e(l,["error","error_description"]),{ok:w}=c;if(!w){const e=p||`HTTP error. Unable to fetch ${t}`;if("mfa_required"===h)throw new m(h,e,g.mfa_token);if("missing_refresh_token"===h)throw new f(o,n);throw new d(h||"request_error",e)}return g}(`${o}/oauth/token`,n,a||"default",r,{method:"POST",body:h,headers:{"Content-Type":u?"application/x-www-form-urlencoded":"application/json","Auth0-Client":btoa(JSON.stringify(c||s))}},i,u)}const j=(...e)=>{return (t=e.filter(Boolean).join(" ").trim().split(/\s+/),Array.from(new Set(t))).join(" ");var t;};class C{constructor(e,t="@@auth0spajs@@",i){this.prefix=t,this.suffix=i,this.clientId=e.clientId,this.scope=e.scope,this.audience=e.audience;}toKey(){return [this.prefix,this.clientId,this.audience,this.scope,this.suffix].filter(Boolean).join("::")}static fromKey(e){const[t,i,o,n]=e.split("::");return new C({clientId:i,scope:n,audience:o},t)}static fromCacheEntry(e){const{scope:t,audience:i,client_id:o}=e;return new C({scope:t,audience:i,clientId:o})}}class z{set(e,t){localStorage.setItem(e,JSON.stringify(t));}get(e){const t=window.localStorage.getItem(e);if(t)try{return JSON.parse(t)}catch(e){return}}remove(e){localStorage.removeItem(e);}allKeys(){return Object.keys(window.localStorage).filter((e=>e.startsWith("@@auth0spajs@@")))}}class P{constructor(){this.enclosedCache=function(){let e={};return {set(t,i){e[t]=i;},get(t){const i=e[t];if(i)return i},remove(t){delete e[t];},allKeys:()=>Object.keys(e)}}();}}class x{constructor(e,t,i){this.cache=e,this.keyManifest=t,this.nowProvider=i||c;}async setIdToken(e,t,i){var o;const n=this.getIdTokenCacheKey(e);await this.cache.set(n,{id_token:t,decodedToken:i}),await(null===(o=this.keyManifest)||void 0===o?void 0:o.add(n));}async getIdToken(e){const t=await this.cache.get(this.getIdTokenCacheKey(e.clientId));if(!t&&e.scope&&e.audience){const t=await this.get(e);if(!t)return;if(!t.id_token||!t.decodedToken)return;return {id_token:t.id_token,decodedToken:t.decodedToken}}if(t)return {id_token:t.id_token,decodedToken:t.decodedToken}}async get(e,t=0){var i;let o=await this.cache.get(e.toKey());if(!o){const t=await this.getCacheKeys();if(!t)return;const i=this.matchExistingCacheKey(e,t);i&&(o=await this.cache.get(i));}if(!o)return;const n=await this.nowProvider(),a=Math.floor(n/1e3);return o.expiresAt-t<a?o.body.refresh_token?(o.body={refresh_token:o.body.refresh_token},await this.cache.set(e.toKey(),o),o.body):(await this.cache.remove(e.toKey()),void await(null===(i=this.keyManifest)||void 0===i?void 0:i.remove(e.toKey()))):o.body}async set(e){var t;const i=new C({clientId:e.client_id,scope:e.scope,audience:e.audience}),o=await this.wrapCacheEntry(e);await this.cache.set(i.toKey(),o),await(null===(t=this.keyManifest)||void 0===t?void 0:t.add(i.toKey()));}async clear(e){var t;const i=await this.getCacheKeys();i&&(await i.filter((t=>!e||t.includes(e))).reduce((async(e,t)=>{await e,await this.cache.remove(t);}),Promise.resolve()),await(null===(t=this.keyManifest)||void 0===t?void 0:t.clear()));}async wrapCacheEntry(e){const t=await this.nowProvider();return {body:e,expiresAt:Math.floor(t/1e3)+e.expires_in}}async getCacheKeys(){var e;return this.keyManifest?null===(e=await this.keyManifest.get())||void 0===e?void 0:e.keys:this.cache.allKeys?this.cache.allKeys():void 0}getIdTokenCacheKey(e){return new C({clientId:e},"@@auth0spajs@@","@@user@@").toKey()}matchExistingCacheKey(e,t){return t.filter((t=>{var i;const o=C.fromKey(t),n=new Set(o.scope&&o.scope.split(" ")),a=(null===(i=e.scope)||void 0===i?void 0:i.split(" "))||[],r=o.scope&&a.reduce(((e,t)=>e&&n.has(t)),!0);return "@@auth0spajs@@"===o.prefix&&o.clientId===e.clientId&&o.audience===e.audience&&r}))[0]}}class Z{constructor(e,t,i){this.storage=e,this.clientId=t,this.cookieDomain=i,this.storageKey=`a0.spajs.txs.${this.clientId}`;}create(e){this.storage.save(this.storageKey,e,{daysUntilExpire:1,cookieDomain:this.cookieDomain});}get(){return this.storage.get(this.storageKey)}remove(){this.storage.remove(this.storageKey,{cookieDomain:this.cookieDomain});}}const K=e=>"number"==typeof e,W=["iss","aud","exp","nbf","iat","jti","azp","nonce","auth_time","at_hash","c_hash","acr","amr","sub_jwk","cnf","sip_from_tag","sip_date","sip_callid","sip_cseq_num","sip_via_branch","orig","dest","mky","events","toe","txn","rph","sid","vot","vtm"],E=e=>{if(!e.id_token)throw new Error("ID token is required but missing");const t=(e=>{const t=e.split("."),[i,o,n]=t;if(3!==t.length||!i||!o||!n)throw new Error("ID token could not be decoded");const a=JSON.parse(b(o)),r={__raw:e},s={};return Object.keys(a).forEach((e=>{r[e]=a[e],W.includes(e)||(s[e]=a[e]);})),{encoded:{header:i,payload:o,signature:n},header:JSON.parse(b(i)),claims:r,user:s}})(e.id_token);if(!t.claims.iss)throw new Error("Issuer (iss) claim must be a string present in the ID token");if(t.claims.iss!==e.iss)throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e.iss}", found "${t.claims.iss}"`);if(!t.user.sub)throw new Error("Subject (sub) claim must be a string present in the ID token");if("RS256"!==t.header.alg)throw new Error(`Signature algorithm of "${t.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);if(!t.claims.aud||"string"!=typeof t.claims.aud&&!Array.isArray(t.claims.aud))throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");if(Array.isArray(t.claims.aud)){if(!t.claims.aud.includes(e.aud))throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but was not one of "${t.claims.aud.join(", ")}"`);if(t.claims.aud.length>1){if(!t.claims.azp)throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");if(t.claims.azp!==e.aud)throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e.aud}", found "${t.claims.azp}"`)}}else if(t.claims.aud!==e.aud)throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but found "${t.claims.aud}"`);if(e.nonce){if(!t.claims.nonce)throw new Error("Nonce (nonce) claim must be a string present in the ID token");if(t.claims.nonce!==e.nonce)throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e.nonce}", found "${t.claims.nonce}"`)}if(e.max_age&&!K(t.claims.auth_time))throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");if(null==t.claims.exp||!K(t.claims.exp))throw new Error("Expiration Time (exp) claim must be a number present in the ID token");if(!K(t.claims.iat))throw new Error("Issued At (iat) claim must be a number present in the ID token");const i=e.leeway||60,o=new Date(e.now||Date.now()),n=new Date(0);if(n.setUTCSeconds(t.claims.exp+i),o>n)throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${o}) is after expiration time (${n})`);if(null!=t.claims.nbf&&K(t.claims.nbf)){const e=new Date(0);if(e.setUTCSeconds(t.claims.nbf-i),o<e)throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${o}) is before ${e}`)}if(null!=t.claims.auth_time&&K(t.claims.auth_time)){const n=new Date(0);if(n.setUTCSeconds(parseInt(t.claims.auth_time)+e.max_age+i),o>n)throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${o}) is after last auth at ${n}`)}if(e.organization){const i=e.organization.trim();if(i.startsWith("org_")){const e=i;if(!t.claims.org_id)throw new Error("Organization ID (org_id) claim must be a string present in the ID token");if(e!==t.claims.org_id)throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_id}"`)}else {const e=i.toLowerCase();if(!t.claims.org_name)throw new Error("Organization Name (org_name) claim must be a string present in the ID token");if(e!==t.claims.org_name)throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_name}"`)}}return t};var R=o((function(e,i){var o=t&&t.__assign||function(){return o=Object.assign||function(e){for(var t,i=1,o=arguments.length;i<o;i++)for(var n in t=arguments[i])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e},o.apply(this,arguments)};function n(e,t){if(!t)return "";var i="; "+e;return !0===t?i:i+"="+t}function a(e,t,i){return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/\(/g,"%28").replace(/\)/g,"%29")+"="+encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent)+function(e){if("number"==typeof e.expires){var t=new Date;t.setMilliseconds(t.getMilliseconds()+864e5*e.expires),e.expires=t;}return n("Expires",e.expires?e.expires.toUTCString():"")+n("Domain",e.domain)+n("Path",e.path)+n("Secure",e.secure)+n("SameSite",e.sameSite)}(i)}function r(e){for(var t={},i=e?e.split("; "):[],o=/(%[\dA-F]{2})+/gi,n=0;n<i.length;n++){var a=i[n].split("="),r=a.slice(1).join("=");'"'===r.charAt(0)&&(r=r.slice(1,-1));try{t[a[0].replace(o,decodeURIComponent)]=r.replace(o,decodeURIComponent);}catch(e){}}return t}function s(){return r(document.cookie)}function c(e,t,i){document.cookie=a(e,t,o({path:"/"},i));}i.__esModule=!0,i.encode=a,i.parse=r,i.getAll=s,i.get=function(e){return s()[e]},i.set=c,i.remove=function(e,t){c(e,"",o(o({},t),{expires:-1}));};}));i(R),R.encode,R.parse,R.getAll;var U=R.get,L=R.set,D=R.remove;const X={get(e){const t=U(e);if(void 0!==t)return JSON.parse(t)},save(e,t,i){let o={};"https:"===window.location.protocol&&(o={secure:!0,sameSite:"none"}),(null==i?void 0:i.daysUntilExpire)&&(o.expires=i.daysUntilExpire),(null==i?void 0:i.cookieDomain)&&(o.domain=i.cookieDomain),L(e,JSON.stringify(t),o);},remove(e,t){let i={};(null==t?void 0:t.cookieDomain)&&(i.domain=t.cookieDomain),D(e,i);}},N={get(e){const t=X.get(e);return t||X.get(`_legacy_${e}`)},save(e,t,i){let o={};"https:"===window.location.protocol&&(o={secure:!0}),(null==i?void 0:i.daysUntilExpire)&&(o.expires=i.daysUntilExpire),(null==i?void 0:i.cookieDomain)&&(o.domain=i.cookieDomain),L(`_legacy_${e}`,JSON.stringify(t),o),X.save(e,t,i);},remove(e,t){let i={};(null==t?void 0:t.cookieDomain)&&(i.domain=t.cookieDomain),D(e,i),X.remove(e,t),X.remove(`_legacy_${e}`,t);}},J={get(e){if("undefined"==typeof sessionStorage)return;const t=sessionStorage.getItem(e);return null!=t?JSON.parse(t):void 0},save(e,t){sessionStorage.setItem(e,JSON.stringify(t));},remove(e){sessionStorage.removeItem(e);}};function F(e,t,i){var o=void 0===t?null:t,n=function(e,t){var i=atob(e);if(t){for(var o=new Uint8Array(i.length),n=0,a=i.length;n<a;++n)o[n]=i.charCodeAt(n);return String.fromCharCode.apply(null,new Uint16Array(o.buffer))}return i}(e,void 0!==i&&i),a=n.indexOf("\n",10)+1,r=n.substring(a)+(o?"//# sourceMappingURL="+o:""),s=new Blob([r],{type:"application/javascript"});return URL.createObjectURL(s)}var H,Y,G,V,M=(H="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",Y=null,G=!1,function(e){return V=V||F(H,Y,G),new Worker(V,e)});const A={};class B{constructor(e,t){this.cache=e,this.clientId=t,this.manifestKey=this.createManifestKeyFrom(this.clientId);}async add(e){var t;const i=new Set((null===(t=await this.cache.get(this.manifestKey))||void 0===t?void 0:t.keys)||[]);i.add(e),await this.cache.set(this.manifestKey,{keys:[...i]});}async remove(e){const t=await this.cache.get(this.manifestKey);if(t){const i=new Set(t.keys);return i.delete(e),i.size>0?await this.cache.set(this.manifestKey,{keys:[...i]}):await this.cache.remove(this.manifestKey)}}get(){return this.cache.get(this.manifestKey)}clear(){return this.cache.remove(this.manifestKey)}createManifestKeyFrom(e){return `@@auth0spajs@@::${e}`}}const $={memory:()=>(new P).enclosedCache,localstorage:()=>new z},q=e=>$[e],Q=t=>{const{openUrl:i,onRedirect:o}=t,n=e(t,["openUrl","onRedirect"]);return Object.assign(Object.assign({},n),{openUrl:!1===i||i?i:o})},ee=new a;class te{constructor(e){let t,i;if(this.userCache=(new P).enclosedCache,this.defaultOptions={authorizationParams:{scope:"openid profile email"},useRefreshTokensFallback:!1,useFormData:!0},this._releaseLockOnPageHide=async()=>{await ee.releaseLock("auth0.lock.getTokenSilently"),window.removeEventListener("pagehide",this._releaseLockOnPageHide);},this.options=Object.assign(Object.assign(Object.assign({},this.defaultOptions),e),{authorizationParams:Object.assign(Object.assign({},this.defaultOptions.authorizationParams),e.authorizationParams)}),"undefined"!=typeof window&&(()=>{if(!w())throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");if(void 0===w().subtle)throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ")})(),e.cache&&e.cacheLocation&&console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."),e.cache)i=e.cache;else {if(t=e.cacheLocation||"memory",!q(t))throw new Error(`Invalid cache location "${t}"`);i=q(t)();}this.httpTimeoutMs=e.httpTimeoutInSeconds?1e3*e.httpTimeoutInSeconds:1e4,this.cookieStorage=!1===e.legacySameSiteCookie?X:N,this.orgHintCookieName=`auth0.${this.options.clientId}.organization_hint`,this.isAuthenticatedCookieName=(e=>`auth0.${e}.is.authenticated`)(this.options.clientId),this.sessionCheckExpiryDays=e.sessionCheckExpiryDays||1;const o=e.useCookiesForTransactions?this.cookieStorage:J;var n;this.scope=j("openid",this.options.authorizationParams.scope,this.options.useRefreshTokens?"offline_access":""),this.transactionManager=new Z(o,this.options.clientId,this.options.cookieDomain),this.nowProvider=this.options.nowProvider||c,this.cacheManager=new x(i,i.allKeys?void 0:new B(i,this.options.clientId),this.nowProvider),this.domainUrl=(n=this.options.domain,/^https?:\/\//.test(n)?n:`https://${n}`),this.tokenIssuer=((e,t)=>e?e.startsWith("https://")?e:`https://${e}/`:`${t}/`)(this.options.issuer,this.domainUrl),"undefined"!=typeof window&&window.Worker&&this.options.useRefreshTokens&&"memory"===t&&(this.options.workerUrl?this.worker=new Worker(this.options.workerUrl):this.worker=new M);}_url(e){const t=encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client||s)));return `${this.domainUrl}${e}&auth0Client=${t}`}_authorizeUrl(e){return this._url(`/authorize?${v(e)}`)}async _verifyIdToken(e,t,i){const o=await this.nowProvider();return E({iss:this.tokenIssuer,aud:this.options.clientId,id_token:e,nonce:t,organization:i,leeway:this.options.leeway,max_age:(n=this.options.authorizationParams.max_age,"string"!=typeof n?n:parseInt(n,10)||void 0),now:o});var n;}_processOrgHint(e){e?this.cookieStorage.save(this.orgHintCookieName,e,{daysUntilExpire:this.sessionCheckExpiryDays,cookieDomain:this.options.cookieDomain}):this.cookieStorage.remove(this.orgHintCookieName,{cookieDomain:this.options.cookieDomain});}async _prepareAuthorizeUrl(e,t,i){const o=k(y()),n=k(y()),a=y(),r=(e=>{const t=new Uint8Array(e);return (e=>{const t={"+":"-","/":"_","=":""};return e.replace(/[+/=]/g,(e=>t[e]))})(window.btoa(String.fromCharCode(...Array.from(t))))})(await(async e=>{const t=w().subtle.digest({name:"SHA-256"},(new TextEncoder).encode(e));return await t})(a)),s=((e,t,i,o,n,a,r,s)=>Object.assign(Object.assign(Object.assign({client_id:e.clientId},e.authorizationParams),i),{scope:j(t,i.scope),response_type:"code",response_mode:s||"query",state:o,nonce:n,redirect_uri:r||e.authorizationParams.redirect_uri,code_challenge:a,code_challenge_method:"S256"}))(this.options,this.scope,e,o,n,r,e.redirect_uri||this.options.authorizationParams.redirect_uri||i,null==t?void 0:t.response_mode),c=this._authorizeUrl(s);return {nonce:n,code_verifier:a,scope:s.scope,audience:s.audience||"default",redirect_uri:s.redirect_uri,state:o,url:c}}async loginWithPopup(e,t){var i;if(e=e||{},!(t=t||{}).popup&&(t.popup=(e=>{const t=window.screenX+(window.innerWidth-400)/2,i=window.screenY+(window.innerHeight-600)/2;return window.open(e,"auth0:authorize:popup",`left=${t},top=${i},width=400,height=600,resizable,scrollbars=yes,status=1`)})(""),!t.popup))throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");const o=await this._prepareAuthorizeUrl(e.authorizationParams||{},{response_mode:"web_message"},window.location.origin);t.popup.location.href=o.url;const n=await(e=>new Promise(((t,i)=>{let o;const n=setInterval((()=>{e.popup&&e.popup.closed&&(clearInterval(n),clearTimeout(a),window.removeEventListener("message",o,!1),i(new p(e.popup)));}),1e3),a=setTimeout((()=>{clearInterval(n),i(new h(e.popup)),window.removeEventListener("message",o,!1);}),1e3*(e.timeoutInSeconds||60));o=function(r){if(r.data&&"authorization_response"===r.data.type){if(clearTimeout(a),clearInterval(n),window.removeEventListener("message",o,!1),e.popup.close(),r.data.response.error)return i(d.fromPayload(r.data.response));t(r.data.response);}},window.addEventListener("message",o);})))(Object.assign(Object.assign({},t),{timeoutInSeconds:t.timeoutInSeconds||this.options.authorizeTimeoutInSeconds||60}));if(o.state!==n.state)throw new d("state_mismatch","Invalid state");const a=(null===(i=e.authorizationParams)||void 0===i?void 0:i.organization)||this.options.authorizationParams.organization;await this._requestToken({audience:o.audience,scope:o.scope,code_verifier:o.code_verifier,grant_type:"authorization_code",code:n.code,redirect_uri:o.redirect_uri},{nonceIn:o.nonce,organization:a});}async getUser(){var e;const t=await this._getIdTokenFromCache();return null===(e=null==t?void 0:t.decodedToken)||void 0===e?void 0:e.user}async getIdTokenClaims(){var e;const t=await this._getIdTokenFromCache();return null===(e=null==t?void 0:t.decodedToken)||void 0===e?void 0:e.claims}async loginWithRedirect(t={}){var i;const o=Q(t),{openUrl:n,fragment:a,appState:r}=o,s=e(o,["openUrl","fragment","appState"]),c=(null===(i=s.authorizationParams)||void 0===i?void 0:i.organization)||this.options.authorizationParams.organization,d=await this._prepareAuthorizeUrl(s.authorizationParams||{}),{url:u}=d,l=e(d,["url"]);this.transactionManager.create(Object.assign(Object.assign(Object.assign({},l),{appState:r}),c&&{organization:c}));const h=a?`${u}#${a}`:u;n?await n(h):window.location.assign(h);}async handleRedirectCallback(e=window.location.href){const t=e.split("?").slice(1);if(0===t.length)throw new Error("There are no query params available for parsing.");const{state:i,code:o,error:n,error_description:a}=(e=>{e.indexOf("#")>-1&&(e=e.substring(0,e.indexOf("#")));const t=new URLSearchParams(e);return {state:t.get("state"),code:t.get("code")||void 0,error:t.get("error")||void 0,error_description:t.get("error_description")||void 0}})(t.join("")),r=this.transactionManager.get();if(!r)throw new d("missing_transaction","Invalid state");if(this.transactionManager.remove(),n)throw new u(n,a||n,i,r.appState);if(!r.code_verifier||r.state&&r.state!==i)throw new d("state_mismatch","Invalid state");const s=r.organization,c=r.nonce,l=r.redirect_uri;return await this._requestToken(Object.assign({audience:r.audience,scope:r.scope,code_verifier:r.code_verifier,grant_type:"authorization_code",code:o},l?{redirect_uri:l}:{}),{nonceIn:c,organization:s}),{appState:r.appState}}async checkSession(e){if(!this.cookieStorage.get(this.isAuthenticatedCookieName)){if(!this.cookieStorage.get("auth0.is.authenticated"))return;this.cookieStorage.save(this.isAuthenticatedCookieName,!0,{daysUntilExpire:this.sessionCheckExpiryDays,cookieDomain:this.options.cookieDomain}),this.cookieStorage.remove("auth0.is.authenticated");}try{await this.getTokenSilently(e);}catch(e){}}async getTokenSilently(e={}){var t;const i=Object.assign(Object.assign({cacheMode:"on"},e),{authorizationParams:Object.assign(Object.assign(Object.assign({},this.options.authorizationParams),e.authorizationParams),{scope:j(this.scope,null===(t=e.authorizationParams)||void 0===t?void 0:t.scope)})}),o=await((e,t)=>{let i=A[t];return i||(i=e().finally((()=>{delete A[t],i=null;})),A[t]=i),i})((()=>this._getTokenSilently(i)),`${this.options.clientId}::${i.authorizationParams.audience}::${i.authorizationParams.scope}`);return e.detailedResponse?o:null==o?void 0:o.access_token}async _getTokenSilently(t){const{cacheMode:i}=t,o=e(t,["cacheMode"]);if("off"!==i){const e=await this._getEntryFromCache({scope:o.authorizationParams.scope,audience:o.authorizationParams.audience||"default",clientId:this.options.clientId});if(e)return e}if("cache-only"!==i){if(!await(async(e,t=3)=>{for(let i=0;i<t;i++)if(await e())return !0;return !1})((()=>ee.acquireLock("auth0.lock.getTokenSilently",5e3)),10))throw new l;try{if(window.addEventListener("pagehide",this._releaseLockOnPageHide),"off"!==i){const e=await this._getEntryFromCache({scope:o.authorizationParams.scope,audience:o.authorizationParams.audience||"default",clientId:this.options.clientId});if(e)return e}const e=this.options.useRefreshTokens?await this._getTokenUsingRefreshToken(o):await this._getTokenFromIFrame(o),{id_token:t,access_token:n,oauthTokenScope:a,expires_in:r}=e;return Object.assign(Object.assign({id_token:t,access_token:n},a?{scope:a}:null),{expires_in:r})}finally{await ee.releaseLock("auth0.lock.getTokenSilently"),window.removeEventListener("pagehide",this._releaseLockOnPageHide);}}}async getTokenWithPopup(e={},t={}){var i;const o=Object.assign(Object.assign({},e),{authorizationParams:Object.assign(Object.assign(Object.assign({},this.options.authorizationParams),e.authorizationParams),{scope:j(this.scope,null===(i=e.authorizationParams)||void 0===i?void 0:i.scope)})});t=Object.assign(Object.assign({},r),t),await this.loginWithPopup(o,t);return (await this.cacheManager.get(new C({scope:o.authorizationParams.scope,audience:o.authorizationParams.audience||"default",clientId:this.options.clientId}))).access_token}async isAuthenticated(){return !!await this.getUser()}_buildLogoutUrl(t){null!==t.clientId?t.clientId=t.clientId||this.options.clientId:delete t.clientId;const i=t.logoutParams||{},{federated:o}=i,n=e(i,["federated"]),a=o?"&federated":"";return this._url(`/v2/logout?${v(Object.assign({clientId:t.clientId},n))}`)+a}async logout(t={}){const i=Q(t),{openUrl:o}=i,n=e(i,["openUrl"]);null===t.clientId?await this.cacheManager.clear():await this.cacheManager.clear(t.clientId||this.options.clientId),this.cookieStorage.remove(this.orgHintCookieName,{cookieDomain:this.options.cookieDomain}),this.cookieStorage.remove(this.isAuthenticatedCookieName,{cookieDomain:this.options.cookieDomain}),this.userCache.remove("@@user@@");const a=this._buildLogoutUrl(n);o?await o(a):!1!==o&&window.location.assign(a);}async _getTokenFromIFrame(e){const t=Object.assign(Object.assign({},e.authorizationParams),{prompt:"none"}),i=this.cookieStorage.get(this.orgHintCookieName);i&&!t.organization&&(t.organization=i);const{url:o,state:n,nonce:a,code_verifier:r,redirect_uri:s,scope:c,audience:u}=await this._prepareAuthorizeUrl(t,{response_mode:"web_message"},window.location.origin);try{if(window.crossOriginIsolated)throw new d("login_required","The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");const i=e.timeoutInSeconds||this.options.authorizeTimeoutInSeconds,h=await((e,t,i=60)=>new Promise(((o,n)=>{const a=window.document.createElement("iframe");a.setAttribute("width","0"),a.setAttribute("height","0"),a.style.display="none";const r=()=>{window.document.body.contains(a)&&(window.document.body.removeChild(a),window.removeEventListener("message",s,!1));};let s;const c=setTimeout((()=>{n(new l),r();}),1e3*i);s=function(e){if(e.origin!=t)return;if(!e.data||"authorization_response"!==e.data.type)return;const i=e.source;i&&i.close(),e.data.response.error?n(d.fromPayload(e.data.response)):o(e.data.response),clearTimeout(c),window.removeEventListener("message",s,!1),setTimeout(r,2e3);},window.addEventListener("message",s,!1),window.document.body.appendChild(a),a.setAttribute("src",e);})))(o,this.domainUrl,i);if(n!==h.state)throw new d("state_mismatch","Invalid state");const p=await this._requestToken(Object.assign(Object.assign({},e.authorizationParams),{code_verifier:r,code:h.code,grant_type:"authorization_code",redirect_uri:s,timeout:e.authorizationParams.timeout||this.httpTimeoutMs}),{nonceIn:a,organization:t.organization});return Object.assign(Object.assign({},p),{scope:c,oauthTokenScope:p.scope,audience:u})}catch(e){throw "login_required"===e.error&&this.logout({openUrl:!1}),e}}async _getTokenUsingRefreshToken(e){const t=await this.cacheManager.get(new C({scope:e.authorizationParams.scope,audience:e.authorizationParams.audience||"default",clientId:this.options.clientId}));if(!(t&&t.refresh_token||this.worker)){if(this.options.useRefreshTokensFallback)return await this._getTokenFromIFrame(e);throw new f(e.authorizationParams.audience||"default",e.authorizationParams.scope)}const i=e.authorizationParams.redirect_uri||this.options.authorizationParams.redirect_uri||window.location.origin,o="number"==typeof e.timeoutInSeconds?1e3*e.timeoutInSeconds:null;try{const n=await this._requestToken(Object.assign(Object.assign(Object.assign({},e.authorizationParams),{grant_type:"refresh_token",refresh_token:t&&t.refresh_token,redirect_uri:i}),o&&{timeout:o}));return Object.assign(Object.assign({},n),{scope:e.authorizationParams.scope,oauthTokenScope:n.scope,audience:e.authorizationParams.audience||"default"})}catch(t){if((t.message.indexOf("Missing Refresh Token")>-1||t.message&&t.message.indexOf("invalid refresh token")>-1)&&this.options.useRefreshTokensFallback)return await this._getTokenFromIFrame(e);throw t}}async _saveEntryInCache(t){const{id_token:i,decodedToken:o}=t,n=e(t,["id_token","decodedToken"]);this.userCache.set("@@user@@",{id_token:i,decodedToken:o}),await this.cacheManager.setIdToken(this.options.clientId,t.id_token,t.decodedToken),await this.cacheManager.set(n);}async _getIdTokenFromCache(){const e=this.options.authorizationParams.audience||"default",t=await this.cacheManager.getIdToken(new C({clientId:this.options.clientId,audience:e,scope:this.scope})),i=this.userCache.get("@@user@@");return t&&t.id_token===(null==i?void 0:i.id_token)?i:(this.userCache.set("@@user@@",t),t)}async _getEntryFromCache({scope:e,audience:t,clientId:i}){const o=await this.cacheManager.get(new C({scope:e,audience:t,clientId:i}),60);if(o&&o.access_token){const{access_token:e,oauthTokenScope:t,expires_in:i}=o,n=await this._getIdTokenFromCache();return n&&Object.assign(Object.assign({id_token:n.id_token,access_token:e},t?{scope:t}:null),{expires_in:i})}}async _requestToken(e,t){const{nonceIn:i,organization:o}=t||{},n=await T(Object.assign({baseUrl:this.domainUrl,client_id:this.options.clientId,auth0Client:this.options.auth0Client,useFormData:this.options.useFormData,timeout:this.httpTimeoutMs},e),this.worker),a=await this._verifyIdToken(n.id_token,i,o);return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({},n),{decodedToken:a,scope:e.scope,audience:e.audience||"default"}),n.scope?{oauthTokenScope:n.scope}:null),{client_id:this.options.clientId})),this.cookieStorage.save(this.isAuthenticatedCookieName,!0,{daysUntilExpire:this.sessionCheckExpiryDays,cookieDomain:this.options.cookieDomain}),this._processOrgHint(o||a.claims.org_id),Object.assign(Object.assign({},n),{decodedToken:a})}}
/**
 * The initial auth state.
 */
var initialAuthState = {
    isAuthenticated: false,
    isLoading: true,
};

/**
 * @ignore
 */
var stub = function () {
    throw new Error('You forgot to wrap your component in <Auth0Provider>.');
};
/**
 * @ignore
 */
var initialContext = __assign(__assign({}, initialAuthState), { buildAuthorizeUrl: stub, buildLogoutUrl: stub, getAccessTokenSilently: stub, getAccessTokenWithPopup: stub, getIdTokenClaims: stub, loginWithRedirect: stub, loginWithPopup: stub, logout: stub, handleRedirectCallback: stub });
/**
 * The Auth0 Context
 */
var Auth0Context = React.createContext(initialContext);

/**
 * An OAuth2 error will come from the authorization server and will have at least an `error` property which will
 * be the error code. And possibly an `error_description` property
 *
 * See: https://openid.net/specs/openid-connect-core-1_0.html#rfc.section.3.1.2.6
 */
var OAuthError = /** @class */ (function (_super) {
    __extends(OAuthError, _super);
    function OAuthError(error, error_description) {
        var _this = _super.call(this, error_description || error) || this;
        _this.error = error;
        _this.error_description = error_description;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, OAuthError.prototype);
        return _this;
    }
    return OAuthError;
}(Error));

var CODE_RE = /[?&]code=[^&]+/;
var STATE_RE = /[?&]state=[^&]+/;
var ERROR_RE = /[?&]error=[^&]+/;
var hasAuthParams = function (searchParams) {
    if (searchParams === void 0) { searchParams = window.location.search; }
    return (CODE_RE.test(searchParams) || ERROR_RE.test(searchParams)) &&
        STATE_RE.test(searchParams);
};
var normalizeErrorFn = function (fallbackMessage) {
    return function (error) {
        if (error instanceof Error) {
            return error;
        }
        // try to check errors of the following form: {error: string; error_description?: string}
        if (error !== null &&
            typeof error === 'object' &&
            'error' in error &&
            typeof error.error === 'string') {
            if ('error_description' in error &&
                typeof error.error_description === 'string') {
                return new OAuthError(error.error, error.error_description);
            }
            return new OAuthError(error.error);
        }
        return new Error(fallbackMessage);
    };
};
var loginError = normalizeErrorFn('Login failed');
var tokenError = normalizeErrorFn('Get access token failed');
/**
 * @ignore
 * Helper function to map the v1 `redirectUri` option to the v2 `authorizationParams.redirect_uri`
 * and log a warning.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var deprecateRedirectUri = function (options) {
    var _a;
    if (options === null || options === void 0 ? void 0 : options.redirectUri) {
        console.warn('Using `redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `redirectUri` will be no longer supported in a future version');
        options.authorizationParams = options.authorizationParams || {};
        options.authorizationParams.redirect_uri = options.redirectUri;
        delete options.redirectUri;
    }
    if ((_a = options === null || options === void 0 ? void 0 : options.authorizationParams) === null || _a === void 0 ? void 0 : _a.redirectUri) {
        console.warn('Using `authorizationParams.redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `authorizationParams.redirectUri` will be removed in a future version');
        options.authorizationParams.redirect_uri =
            options.authorizationParams.redirectUri;
        delete options.authorizationParams.redirectUri;
    }
};

/**
 * Handles how that state changes in the `useAuth0` hook.
 */
var reducer = function (state, action) {
    switch (action.type) {
        case 'LOGIN_POPUP_STARTED':
            return __assign(__assign({}, state), { isLoading: true });
        case 'LOGIN_POPUP_COMPLETE':
        case 'INITIALISED':
            return __assign(__assign({}, state), { isAuthenticated: !!action.user, user: action.user, isLoading: false, error: undefined });
        case 'HANDLE_REDIRECT_COMPLETE':
        case 'GET_ACCESS_TOKEN_COMPLETE':
            if (state.user === action.user) {
                return state;
            }
            return __assign(__assign({}, state), { isAuthenticated: !!action.user, user: action.user });
        case 'LOGOUT':
            return __assign(__assign({}, state), { isAuthenticated: false, user: undefined });
        case 'ERROR':
            return __assign(__assign({}, state), { isLoading: false, error: action.error });
    }
};

/**
 * @ignore
 */
var toAuth0ClientOptions = function (opts) {
    deprecateRedirectUri(opts);
    return __assign(__assign({}, opts), { auth0Client: {
            name: 'auth0-react',
            version: '2.3.0',
        } });
};
/**
 * @ignore
 */
var defaultOnRedirectCallback = function (appState) {
    window.history.replaceState({}, document.title, (appState === null || appState === void 0 ? void 0 : appState.returnTo) || window.location.pathname);
};
/**
 * ```jsx
 * <Auth0Provider
 *   domain={domain}
 *   clientId={clientId}
 *   authorizationParams={{ redirect_uri: window.location.origin }}>
 *   <MyApp />
 * </Auth0Provider>
 * ```
 *
 * Provides the Auth0Context to its child components.
 */
var Auth0Provider = function (opts) {
    var children = opts.children, skipRedirectCallback = opts.skipRedirectCallback, _a = opts.onRedirectCallback, onRedirectCallback = _a === void 0 ? defaultOnRedirectCallback : _a, _b = opts.context, context = _b === void 0 ? Auth0Context : _b, clientOpts = __rest(opts, ["children", "skipRedirectCallback", "onRedirectCallback", "context"]);
    var client = React.useState(function () { return new te(toAuth0ClientOptions(clientOpts)); })[0];
    var _c = React.useReducer(reducer, initialAuthState), state = _c[0], dispatch = _c[1];
    var didInitialise = React.useRef(false);
    var handleError = React.useCallback(function (error) {
        dispatch({ type: 'ERROR', error: error });
        return error;
    }, []);
    React.useEffect(function () {
        if (didInitialise.current) {
            return;
        }
        didInitialise.current = true;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var user, appState, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        user = void 0;
                        if (!(hasAuthParams() && !skipRedirectCallback)) return [3 /*break*/, 3];
                        return [4 /*yield*/, client.handleRedirectCallback()];
                    case 1:
                        appState = (_a.sent()).appState;
                        return [4 /*yield*/, client.getUser()];
                    case 2:
                        user = _a.sent();
                        onRedirectCallback(appState, user);
                        return [3 /*break*/, 6];
                    case 3: return [4 /*yield*/, client.checkSession()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, client.getUser()];
                    case 5:
                        user = _a.sent();
                        _a.label = 6;
                    case 6:
                        dispatch({ type: 'INITIALISED', user: user });
                        return [3 /*break*/, 8];
                    case 7:
                        error_1 = _a.sent();
                        handleError(loginError(error_1));
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        }); })();
    }, [client, onRedirectCallback, skipRedirectCallback, handleError]);
    var loginWithRedirect = React.useCallback(function (opts) {
        deprecateRedirectUri(opts);
        return client.loginWithRedirect(opts);
    }, [client]);
    var loginWithPopup = React.useCallback(function (options, config) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2, user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: 'LOGIN_POPUP_STARTED' });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.loginWithPopup(options, config)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    handleError(loginError(error_2));
                    return [2 /*return*/];
                case 4: return [4 /*yield*/, client.getUser()];
                case 5:
                    user = _a.sent();
                    dispatch({ type: 'LOGIN_POPUP_COMPLETE', user: user });
                    return [2 /*return*/];
            }
        });
    }); }, [client]);
    var logout = React.useCallback(function (opts) {
        if (opts === void 0) { opts = {}; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, client.logout(opts)];
                    case 1:
                        _a.sent();
                        if (opts.openUrl || opts.openUrl === false) {
                            dispatch({ type: 'LOGOUT' });
                        }
                        return [2 /*return*/];
                }
            });
        });
    }, [client]);
    var getAccessTokenSilently = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (opts) { return __awaiter(void 0, void 0, void 0, function () {
        var token, error_3, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, 3, 5]);
                    return [4 /*yield*/, client.getTokenSilently(opts)];
                case 1:
                    token = _c.sent();
                    return [3 /*break*/, 5];
                case 2:
                    error_3 = _c.sent();
                    throw tokenError(error_3);
                case 3:
                    _a = dispatch;
                    _b = {
                        type: 'GET_ACCESS_TOKEN_COMPLETE'
                    };
                    return [4 /*yield*/, client.getUser()];
                case 4:
                    _a.apply(void 0, [(_b.user = _c.sent(),
                            _b)]);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/, token];
            }
        });
    }); }, [client]);
    var getAccessTokenWithPopup = React.useCallback(function (opts, config) { return __awaiter(void 0, void 0, void 0, function () {
        var token, error_4, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, 3, 5]);
                    return [4 /*yield*/, client.getTokenWithPopup(opts, config)];
                case 1:
                    token = _c.sent();
                    return [3 /*break*/, 5];
                case 2:
                    error_4 = _c.sent();
                    throw tokenError(error_4);
                case 3:
                    _a = dispatch;
                    _b = {
                        type: 'GET_ACCESS_TOKEN_COMPLETE'
                    };
                    return [4 /*yield*/, client.getUser()];
                case 4:
                    _a.apply(void 0, [(_b.user = _c.sent(),
                            _b)]);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/, token];
            }
        });
    }); }, [client]);
    var getIdTokenClaims = React.useCallback(function () { return client.getIdTokenClaims(); }, [client]);
    var handleRedirectCallback = React.useCallback(function (url) { return __awaiter(void 0, void 0, void 0, function () {
        var error_5, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, 3, 5]);
                    return [4 /*yield*/, client.handleRedirectCallback(url)];
                case 1: return [2 /*return*/, _c.sent()];
                case 2:
                    error_5 = _c.sent();
                    throw tokenError(error_5);
                case 3:
                    _a = dispatch;
                    _b = {
                        type: 'HANDLE_REDIRECT_COMPLETE'
                    };
                    return [4 /*yield*/, client.getUser()];
                case 4:
                    _a.apply(void 0, [(_b.user = _c.sent(),
                            _b)]);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [client]);
    var contextValue = React.useMemo(function () {
        return __assign(__assign({}, state), { getAccessTokenSilently: getAccessTokenSilently, getAccessTokenWithPopup: getAccessTokenWithPopup, getIdTokenClaims: getIdTokenClaims, loginWithRedirect: loginWithRedirect, loginWithPopup: loginWithPopup, logout: logout, handleRedirectCallback: handleRedirectCallback });
    }, [
        state,
        getAccessTokenSilently,
        getAccessTokenWithPopup,
        getIdTokenClaims,
        loginWithRedirect,
        loginWithPopup,
        logout,
        handleRedirectCallback,
    ]);
    return React__default.createElement(context.Provider, { value: contextValue }, children);
};

/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   isLoading,
 *   user,
 *   // Auth methods:
 *   getAccessTokenSilently,
 *   getAccessTokenWithPopup,
 *   getIdTokenClaims,
 *   loginWithRedirect,
 *   loginWithPopup,
 *   logout,
 * } = useAuth0<TUser>();
 * ```
 *
 * Use the `useAuth0` hook in your components to access the auth state and methods.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */
var useAuth0 = function (context) {
    if (context === void 0) { context = Auth0Context; }
    return React.useContext(context);
};

function AuthProvider(_ref) {
  var children = _ref.children,
      _ref$config = _ref.config,
      config = _ref$config === undefined ? {} : _ref$config;

  return React__default.createElement(
    Auth0Provider,
    {
      domain: config.domain,
      clientId: config.clientId,
      authorizationParams: {
        scope: config.scope,
        audience: config.audience
      },
      useCookiesForTransactions: true,
      cacheLocation: 'localstorage',
      useRefreshTokens: true
    },
    children
  );
}

// Auth0 Authentication API
var AUTH_API = {
  REVOKE_REFRESH_TOKEN: '/oauth/revoke'
};

var GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
var GET_PROFILE_FAILED = 'GET_PROFILE_FAILED';
var CLEAR_PROFILE = 'CLEAR_PROFILE';

var API_USER = {
  INFO: '/api/v2/user/me',
  LOGOUT: '/api/v2/user/logout'
};

var authAxios = function authAxios(_ref) {
  var baseURL = _ref.baseURL;
  return function () {
    var instance = axios.create({
      baseURL: baseURL
    });

    return instance;
  };
};

/* eslint-disable no-console */
var LOG_LEVELS = { DEBUG: 0, INFO: 1, WARN: 2, ERROR: 3 };
var CURRENT_LEVEL = process.env.NODE_ENV !== 'production' ? LOG_LEVELS.DEBUG : LOG_LEVELS.INFO;

var logger = {
  debug: function debug() {
    var _console;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return CURRENT_LEVEL <= LOG_LEVELS.DEBUG && (_console = console).debug.apply(_console, ['[DEBUG]'].concat(args));
  },
  info: function info() {
    var _console2;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return CURRENT_LEVEL <= LOG_LEVELS.INFO && (_console2 = console).info.apply(_console2, ['[INFO]'].concat(args));
  },
  warn: function warn() {
    var _console3;

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return CURRENT_LEVEL <= LOG_LEVELS.WARN && (_console3 = console).warn.apply(_console3, ['[WARN]'].concat(args));
  },
  error: function error() {
    var _console4;

    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return CURRENT_LEVEL <= LOG_LEVELS.ERROR && (_console4 = console).error.apply(_console4, ['[ERROR]'].concat(args));
  }
};

var _this = undefined;

var userAxios = function userAxios(_ref) {
  var domain = _ref.domain,
      baseURL = _ref.baseURL,
      getAccessToken = _ref.getAccessToken;
  return function () {
    var instance = axios.create({
      baseURL: baseURL,
      headers: {
        Authorization: 'Bearer ' + getUserToken()
      }
    });

    // Auth0 Migration
    var request = function () {
      var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(requestConfig) {
        var headers, accessToken;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                headers = lodash_get(requestConfig, 'headers', {});

                if (!(getAccessToken && getAccessToken instanceof Function)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return getAccessToken();

              case 4:
                accessToken = _context.sent;

                headers.Authorization = 'Bearer ' + accessToken;

              case 6:
                return _context.abrupt('return', _extends({}, requestConfig, { headers: headers }));

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function request(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    var handleAuthorization = getHandleAuthorization({
      domain: domain,
      authAPIBase: baseURL,
      axiosInstance: instance
    });

    instance.interceptors.request.use(request);
    instance.interceptors.response.use(function (response) {
      return response.data;
    }, handleAuthorization);
    return instance;
  };
};

var _this$1 = undefined;

var useAuth = function useAuth(authConfig, configApi) {
  var _useAuth = useAuth0(),
      authLogout = _useAuth.logout,
      isAuthenticated = _useAuth.isAuthenticated,
      isLoading = _useAuth.isLoading,
      getAccessToken = _useAuth.getAccessTokenSilently;

  var _useMemo = React.useMemo(function () {
    var shouldUseAuthProvider = !isLoading && isAuthenticated;
    var axiosConfig = shouldUseAuthProvider ? _extends({}, configApi, { getAccessToken: getAccessToken }) : configApi;

    var axios$$1 = userAxios(axiosConfig);
    var profileApi = function profileApi(method, data) {
      return axios$$1()[method](API_USER.INFO, data);
    };
    var logoutApi = function logoutApi() {
      return axios$$1().post(API_USER.LOGOUT, undefined, {
        withCredentials: true
      });
    };
    var authRevokeRefreshToken = function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _ref2, clientId, audience, scope, domain, authTokenKey, refreshToken, authApiInstance;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref2 = authConfig || {}, clientId = _ref2.clientId, audience = _ref2.audience, scope = _ref2.scope, domain = _ref2.domain;
                authTokenKey = '@@auth0spajs@@::' + clientId + '::' + audience + '::' + scope;
                // eslint-disable-next-line camelcase

                refreshToken = lodash_get(JSON.parse(localStorage.getItem(authTokenKey)), 'body.refresh_token');

                if (!refreshToken) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 4;
                authApiInstance = authAxios({ baseURL: 'https://' + domain });
                _context.next = 8;
                return authApiInstance().post(AUTH_API.REVOKE_REFRESH_TOKEN, {
                  client_id: clientId,
                  token: refreshToken
                });

              case 8:
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                logger.error(_context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this$1, [[4, 10]]);
      }));

      return function authRevokeRefreshToken() {
        return _ref.apply(this, arguments);
      };
    }();

    return {
      logout: function () {
        var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(tracker) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return logoutApi();

                case 2:
                  tracker.logout();

                  if (!shouldUseAuthProvider) {
                    _context2.next = 10;
                    break;
                  }

                  _context2.next = 6;
                  return authRevokeRefreshToken();

                case 6:
                  _context2.next = 8;
                  return authLogout({
                    logoutParams: {
                      returnTo: window.location.origin
                    },
                    openUrl: function openUrl(clearSessionUrl) {
                      window.location.replace(clearSessionUrl);
                    }
                  });

                case 8:
                  _context2.next = 11;
                  break;

                case 10:
                  redirect('/');

                case 11:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this$1);
        }));

        return function logout(_x) {
          return _ref3.apply(this, arguments);
        };
      }(),
      changeUserType: function () {
        var _ref4 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(userType) {
          var user, type, url;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return profileApi('put', { userType: userType });

                case 2:
                  user = _context3.sent;
                  type = lodash_get(user, 'result.userType');
                  url = generateUrlByUserType(type);

                  redirect(url);

                case 6:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this$1);
        }));

        return function changeUserType(_x2) {
          return _ref4.apply(this, arguments);
        };
      }()
    };
  }, [configApi, authLogout, isAuthenticated, isLoading, getAccessToken, authConfig]),
      logout = _useMemo.logout,
      changeUserType = _useMemo.changeUserType;

  return { logout: logout, changeUserType: changeUserType };
};

function NavbarContainer(props) {
  var configApi = props.configApi,
      tracker = props.tracker,
      authConfig = props.authConfig;

  var _useAuth = useAuth(authConfig, configApi),
      changeUserType = _useAuth.changeUserType,
      logout = _useAuth.logout;

  return React__default.createElement(Navbar$1, _extends({}, props, { changeUserType: changeUserType, handleLogout: function handleLogout() {
      return logout(tracker);
    } }));
}

NavbarContainer.propTypes = {
  configApi: PropTypes.object.isRequired,
  subdomain: PropTypes.string,
  customLogoHeight: PropTypes.string,
  profile: PropTypes.object,
  tracker: PropTypes.object.isRequired,
  isShowRenterSupport: PropTypes.bool,
  authConfig: PropTypes.object
};

function NavbarProvider(props) {
  var authConfig = props.authConfig;

  return React__default.createElement(
    AuthProvider,
    { config: authConfig },
    React__default.createElement(NavbarContainer, props)
  );
}

var profileInitState = {};
function profileReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : profileInitState;
  var action = arguments[1];

  switch (action.type) {
    case GET_PROFILE_SUCCESS:
      return lodash_get(action, 'payload', {});
    case GET_PROFILE_FAILED:
    case CLEAR_PROFILE:
      return profileInitState;
    default:
      return state;
  }
}

var reducers = {
  profileReducer: profileReducer
};

var _templateObject$3 = taggedTemplateLiteral(['\n  @import url(\'https://fonts.googleapis.com/css?family=Nunito+Sans:400,600,700,800&display=swap\');\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);\n  font-family: Nunito Sans, sans-serif;\n  color: #010a73;\n  height: 70px;\n  width: 100vw;\n  position: relative;\n  z-index: 1500;\n  top: 0px;\n  display: block;\n  background-color: white !important;\n  -webkit-font-smoothing: auto !important;\n  @media (max-width: 968px) {\n    border-bottom: 1px solid #cacccc;\n    box-shadow: none;\n  }\n  a {\n    color: #010a73;\n  }\n  a:active {\n    color: #010a73;\n  }\n  > .wrapper {\n    float: left;\n    padding: 0px 33px 0px 23px;\n    text-align: center;\n    width: 97vw;\n\n    > .home {\n      width: 230px;\n      align-items: center;\n      display: flex;\n      float: left;\n      height: 70px;\n\n      > .logo {\n        margin-left: 16px;\n        margin-top: 2px;\n        z-index: 1502;\n        > a > img {\n          height: 32px;\n          vertical-align: unset !important;\n        }\n      }\n    }\n  }\n'], ['\n  @import url(\'https://fonts.googleapis.com/css?family=Nunito+Sans:400,600,700,800&display=swap\');\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);\n  font-family: Nunito Sans, sans-serif;\n  color: #010a73;\n  height: 70px;\n  width: 100vw;\n  position: relative;\n  z-index: 1500;\n  top: 0px;\n  display: block;\n  background-color: white !important;\n  -webkit-font-smoothing: auto !important;\n  @media (max-width: 968px) {\n    border-bottom: 1px solid #cacccc;\n    box-shadow: none;\n  }\n  a {\n    color: #010a73;\n  }\n  a:active {\n    color: #010a73;\n  }\n  > .wrapper {\n    float: left;\n    padding: 0px 33px 0px 23px;\n    text-align: center;\n    width: 97vw;\n\n    > .home {\n      width: 230px;\n      align-items: center;\n      display: flex;\n      float: left;\n      height: 70px;\n\n      > .logo {\n        margin-left: 16px;\n        margin-top: 2px;\n        z-index: 1502;\n        > a > img {\n          height: 32px;\n          vertical-align: unset !important;\n        }\n      }\n    }\n  }\n']);

var StyledNavbarRental = styled__default.header(_templateObject$3);

var NavbarRentals = function (_React$Component) {
  inherits(NavbarRentals, _React$Component);

  function NavbarRentals(props) {
    classCallCheck(this, NavbarRentals);

    var _this = possibleConstructorReturn(this, (NavbarRentals.__proto__ || Object.getPrototypeOf(NavbarRentals)).call(this, props));

    _this.partnerLogoSrc = get_1(props, 'partnerLogoSrc', 'https://cdn.rentspree.com/static-files/logos/rent-logo.png');
    _this.domain = get_1(props, 'domain', 'https://www.rentals.com');
    return _this;
  }

  createClass(NavbarRentals, [{
    key: 'render',
    value: function render() {
      return React__default.createElement(
        StyledNavbarRental,
        null,
        React__default.createElement(
          'div',
          { className: 'wrapper' },
          React__default.createElement(
            'div',
            { className: 'home' },
            React__default.createElement(
              'div',
              { className: 'logo' },
              React__default.createElement(
                'a',
                { href: this.domain, target: '_blank', rel: 'noreferrer' },
                React__default.createElement('img', { src: this.partnerLogoSrc, alt: 'Rent' })
              )
            )
          )
        )
      );
    }
  }]);
  return NavbarRentals;
}(React__default.Component);

var HeaderEdgeImg = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20viewBox%3D%22192%2051%2072%2060%22%20enable-background%3D%22new%20192%2051%2072%2060%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpath%20id%3D%22b_1_%22%20fill%3D%22%23FFFFFF%22%20d%3D%22M192%2C51h72v60c-13.9%2C0-27.2-6.2-36.1-16.9L192%2C51z%22%2F%3E%3C%2Fsvg%3E";

var LOGO_HEADER_HEIGHT = '50px';
var LOGO_HEADER_WIDTH = '320px';
var LOGO_HEADER_HEIGHT_MOBILE = '60px';
var LOGO_HEIGHT = '30px';
var SUBDOMAIN_LOGO_HEIGHT = '40px';

var _templateObject$4 = taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  height: ', ';\n  justify-content: center;\n  filter: drop-shadow(2px 5px 4px rgba(0, 0, 0, 0.23));\n  @media (max-width: 767px) {\n    filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0));\n    height: ', ';\n    background-image: none;\n    background-color: white;\n    width: 100%;\n    border-radius: 0px;\n    margin: 15px 0;\n    text-align: center;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  height: ', ';\n  justify-content: center;\n  filter: drop-shadow(2px 5px 4px rgba(0, 0, 0, 0.23));\n  @media (max-width: 767px) {\n    filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0));\n    height: ', ';\n    background-image: none;\n    background-color: white;\n    width: 100%;\n    border-radius: 0px;\n    margin: 15px 0;\n    text-align: center;\n  }\n']),
    _templateObject2$3 = taggedTemplateLiteral(['\n  height: ', ';\n  @media (max-width: 767px) {\n    display: none;\n  }\n'], ['\n  height: ', ';\n  @media (max-width: 767px) {\n    display: none;\n  }\n']),
    _templateObject3$3 = taggedTemplateLiteral(['\n  height: ', ';\n  transform: scaleX(-1);\n  @media (max-width: 767px) {\n    display: none;\n  }\n'], ['\n  height: ', ';\n  transform: scaleX(-1);\n  @media (max-width: 767px) {\n    display: none;\n  }\n']),
    _templateObject4$2 = taggedTemplateLiteral(['\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ', ';\n  min-width: ', ';\n  background-color: white;\n  @media (max-width: 767px) {\n    width: 100%;\n    height: ', ';\n  }\n'], ['\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ', ';\n  min-width: ', ';\n  background-color: white;\n  @media (max-width: 767px) {\n    width: 100%;\n    height: ', ';\n  }\n']),
    _templateObject5$2 = taggedTemplateLiteral(['\n  height: ', ';\n  margin: 0px 10px;\n'], ['\n  height: ', ';\n  margin: 0px 10px;\n']);

var StyledHeader = styled__default.div(_templateObject$4, LOGO_HEADER_HEIGHT, LOGO_HEADER_HEIGHT_MOBILE);

var HeaderLeft = styled__default.img(_templateObject2$3, LOGO_HEADER_HEIGHT);
var HeaderRight = styled__default.img(_templateObject3$3, LOGO_HEADER_HEIGHT);
var HeaderCenter = styled__default.div(_templateObject4$2, LOGO_HEADER_HEIGHT, LOGO_HEADER_WIDTH, LOGO_HEADER_HEIGHT_MOBILE);

var Logo = styled__default.img(_templateObject5$2, LOGO_HEIGHT);
var PartnerLogo = styled__default.img(_templateObject5$2, SUBDOMAIN_LOGO_HEIGHT);

var AuthWebNavbar = function (_React$Component) {
  inherits(AuthWebNavbar, _React$Component);

  function AuthWebNavbar() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, AuthWebNavbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = AuthWebNavbar.__proto__ || Object.getPrototypeOf(AuthWebNavbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { imgLoadFailed: false }, _this.handleOnError = function () {
      return _this.setState({ imgLoadFailed: true });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(AuthWebNavbar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          partnerLogoSrc = _props.partnerLogoSrc;
      var imgLoadFailed = this.state.imgLoadFailed;

      return React__default.createElement(
        StyledHeader,
        { id: 'logoHeader', className: className },
        React__default.createElement(HeaderLeft, { src: HeaderEdgeImg }),
        React__default.createElement(
          HeaderCenter,
          null,
          React__default.createElement(Logo, { src: RENTSPREE_NAVBAR_LOGO_URL, alt: 'RentSpree Logo' }),
          partnerLogoSrc && !imgLoadFailed && React__default.createElement(PartnerLogo, { src: partnerLogoSrc, onError: this.handleOnError })
        ),
        React__default.createElement(HeaderRight, { src: HeaderEdgeImg })
      );
    }
  }]);
  return AuthWebNavbar;
}(React__default.Component);

exports.TopNavbar = NavbarProvider;
exports.AuthWebNavbar = AuthWebNavbar;
exports.Navbar = Navbar$1;
exports.reducers = reducers;
exports.NavbarRentals = NavbarRentals;
//# sourceMappingURL=index.js.map
